import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { Spin } from "antd";
import {
  convertTimeToDateTime,
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import Cropper from "react-cropper";
import {
  dataUrlToFile,
  dataUrlToFileUsingFetch,
} from "../../../CustomControls/Utils";
import "cropperjs/dist/cropper.css";
import Webcam from "react-webcam";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerDDLList,
  POST_GetCustomerProjectContactPersonDDLList,
  POST_GetCustomerProjectList,
  POST_GetDDLTestMasterByDepartmentProductGroupMaterialType,
  POST_GetDepartmentDropDownList,
  POST_GetMaterialInwardProjectWorkDetailDDLList,
  POST_GetMaterialTypeDDLListByDepartment_ProductGroup,
  POST_GetTCAllocationDetail,
  POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
  POST_GetVoucherSeriesDDLList,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_TCAllocationSave,
  POST_GetMachiningProcessDDLList,
  POST_GetCustomerContactPersonDDL,
  POST_ProductGroupDropDownList,
  POST_GetDepartmentDropDownListByProductGroup,
  POST_GetTestParametersList,
  POST_GetMixDesignMasterDropDownListAll,
  POST_GetTestWiseDefineMoreRatesList,
  POST_GetReferenceStandardTestSubGroupDDL,
  POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInputUncontrolled from "../../../CustomControls/CustomInputUncontrolled";
import CustomTextAreaUncontrolled from "../../../CustomControls/CustomTextAreaUncontrolled";

const AddTC_TestAllocation = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam, ViewPrimaryIdParam } = useParams();

  const [projectOptions, setProjectOptions] = useState([]);
  const [stampWriteUpOptions, setStampWriteUpOptions] = useState([]);
  const [tcNoOptions, setTCNoOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  const [stampImage, setStampImage] = useState(null);
  const [stampImageFile, setStampImageFile] = useState(null);

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [showMaterialInfoImagesModal, setShowMaterialInfoImagesModal] =
    useState(false);

  const [showMaterialProcessModal, setShowMaterialProcessModal] =
    useState(false);
  const [processNameOptions, setProcessNameOptions] = useState([]);

  const [
    showMaterialInfoRepeatRowQtyModal,
    setShowMaterialInfoRepeatRowQtyModal,
  ] = useState(false);
  const [showWorkDetailModal, setShowWorkDetailModal] = useState(false);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };
  const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const getProjectDDL = async () => {
    // setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item?.ProjectName,
              value: item?.CustomerProjectIDEncrypt,
            })),
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x?.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted,
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
          } else {
            // /*select the value when there is only one option while insert only*/
            // if (
            //   response?.CustomerProjectDDLList?.length == 1 &&
            //   !PrimaryIdParam
            // ) {
            //   formik.setFieldValue(
            //     "CustomerProjectIDEncrypted",
            //     response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
            //   );
            // }
          }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getStampWriteUpDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerProjectContactPersonDDLList, {
  //     CustomerIDEncrypted: CustomerIDEncrypted,
  //     CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setStampWriteUpOptions(
  //           response?.ContactPersonDDLList?.filter(
  //             (x) => x.StempWriteup != ""
  //           )?.map((item) => ({
  //             label: item.StempWriteup,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //         if (
  //           response?.ContactPersonDDLList?.filter((x) => x.StempWriteup != "")
  //             ?.length > 0 &&
  //           StampWriteUpIDEncrypted &&
  //           response?.ContactPersonDDLList?.filter(
  //             (x) => x.StempWriteup != ""
  //           )?.filter(
  //             (x) =>
  //               x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted
  //           ).length == 0
  //         ) {
  //           formik.setFieldValue("StampWriteUpIDEncrypted", "");
  //         } else {
  //           // /*select the value when there is only one option while insert only*/
  //           // if (
  //           //   response?.ContactPersonDDLList?.length == 1 &&
  //           //   !PrimaryIdParam
  //           // ) {
  //           //   formik.setFieldValue(
  //           //     "StampWriteUpIDEncrypted",
  //           //     response?.ContactPersonDDLList[0]
  //           //       .CustomerContactPersonIDEncrypted
  //           //   );
  //           // }
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getStampWriteUpDDL = async () => {
    // setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStampWriteUpOptions(
            response?.ListOfContactPersons?.filter(
              (x) => x?.StempWriteup != "",
            )?.map((item) => ({
              label: item?.StempWriteup,
              value: item?.CustomerContactPersonIDEncrypted,
            })),
          );
          if (
            response?.ListOfContactPersons?.filter((x) => x?.StempWriteup != "")
              ?.length > 0 &&
            StampWriteUpIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) => x?.StempWriteup != "",
            )?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted,
            ).length == 0
          ) {
            formik.setFieldValue("StampWriteUpIDEncrypted", "");
          }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getTPIContactPersonDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerProjectContactPersonDDLList, {
  //     CustomerIDEncrypted: TPIIDEncrypted,
  //     CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setTPIContactPersonOptions(
  //           response?.ContactPersonDDLList?.map((item) => ({
  //             label: item.ContactPerson,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item?.ContactPerson,
              value: item?.CustomerContactPersonIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL = async () => {
    // setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: 1, // 1 = TPI Only
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x?.IsTPI == true)?.map(
              (item) => ({
                label: item?.CustomerName,
                value: item?.CustomerIDEncrypted,
              }),
            ),
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDepartmentDDL = async () => {
    // setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TransactionDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item?.DepartmentName,
              value: item?.DepartmentIDEncrypted,
              IsNABLScopeExpired: item?.IsNABLScopeExpired,
            })),
          );
          // /*select the value when there is only one option while insert only*/
          // if (response?.List?.length == 1 && !PrimaryIdParam) {
          //   ListOfMaterials?.map((x, i) => {
          //     formik.setFieldValue(
          //       `ListOfMaterials[${i}].DepartmentIDEncrypted`,
          //       response?.List[0].DepartmentIDEncrypted
          //     );
          //     getProductGroupDDL(response?.List[0].DepartmentIDEncrypted, i);
          //   });
          // }
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getDepartmentDDL = async (productGroupID, index) => {
  //   if (productGroupID) {
  //     setIsLoading(true);
  //     await post(POST_GetDepartmentDropDownListByProductGroup, {
  //       ProductGroupIDEncrypted: productGroupID,
  //       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfMaterials[${index}].departmentOptions`,
  //             response?.List?.map((item) => ({
  //               label: item?.DepartmentName,
  //               value: item?.DepartmentIDEncrypted,
  //             }))
  //           );
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     formik.setFieldValue(`ListOfMaterials[${index}].departmentOptions`, []);
  //     formik.setFieldValue(
  //       `ListOfMaterials[${index}].ListOfMaterialTestDetails`,
  //       ListOfMaterials[index]?.ListOfMaterialTestDetails?.map((x) => {
  //         return {
  //           ...x,
  //           TestMasterIDEncrypted: "",
  //           TestMethodIDEncrypted: "",
  //           ReferenceStandardIDEncrypted: "",
  //           testOptions: [],
  //           testMethodOptions: [],
  //           referenceStandardOptions: [],
  //         };
  //       })
  //     );
  //   }
  // };

  // // const getProductGroupDDL = async (departmentID, index) => {
  // //   if (departmentID) {
  // //     setIsLoading(true);
  // //     await post(POST_ProductGroupDropDownListByDepartmentID, {
  // //       DepartmentIDEncrypt: departmentID,
  // //       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  // //     })
  // //       .then((response) => {
  // //         if (response?.IsSuccess) {
  // //           formik.setFieldValue(
  // //             `ListOfMaterials[${index}].productGroupOptions`,
  // //             response?.ProductGroupDropDownList?.map((item) => ({
  // //               label: item?.ProductGroupName,
  // //               value: item?.ProductGroupIDEncrypt,
  // //             }))
  // //           );
  // //           // /*select the value when there is only one option while insert only*/
  // //           // if (
  // //           //   response?.ProductGroupDropDownList?.length == 1 &&
  // //           //   !PrimaryIdParam
  // //           // ) {
  // //           //   formik.setFieldValue(
  // //           //     `ListOfMaterials[${index}].ProductGroupIDEncrypted`,
  // //           //     response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
  // //           //   );
  // //           //   getMaterialTypeDDL(
  // //           //     departmentID,
  // //           //     response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt,
  // //           //     index
  // //           //   );
  // //           // }
  // //         }
  // //         setIsLoading(false);
  // //       })
  // //       .catch((error) => {
  // //         console.log(error);
  // //         setIsLoading(false);
  // //       });
  // //   } else {
  // //     formik.setFieldValue(`ListOfMaterials[${index}].productGroupOptions`, []);
  // //     formik.setFieldValue(
  // //       `ListOfMaterials[${index}].ProductGroupIDEncrypted`,
  // //       ""
  // //     );
  // //   }
  // // };

  // const getProductGroupDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_ProductGroupDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setProductGroupOptions(
  //           response?.ProductGroupDropDownList?.map((item) => ({
  //             label: item.ProductGroupName,
  //             value: item.ProductGroupIDEncrypt,
  //           }))
  //         );

  //         // /*select the value when there is only one option while insert only*/
  //         // if (
  //         //   response?.ProductGroupDropDownList?.length == 1 &&
  //         //   !PrimaryIdParam
  //         // ) {
  //         //   ListOfMaterials?.map((x, i) => {
  //         //     formik.setFieldValue(
  //         //       `ListOfMaterials[${i}].ProductGroupIDEncrypted`,
  //         //       response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
  //         //     );
  //         //     getMaterialTypeDDL(
  //         //       response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt,
  //         //       i
  //         //     );
  //         //   });
  //         // }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const getMaterialTypeDDL = async (departmentID, productGroupID, index) => {
  //   if (departmentID && productGroupID) {
  //     setIsLoading(true);
  //     await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
  //       DepartmentIDEncrypted: departmentID,
  //       ProductGroupIDEncrypted: productGroupID,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfMaterials[${index}].materialTypeOptions`,
  //             response?.MaterialTypeList?.map((item) => ({
  //               label: item?.MaterialTypeName,
  //               value: item?.MaterialTypeIDEncrypted,
  //             }))
  //           );
  //           // /*select the value when there is only one option while insert only*/
  //           // if (response?.MaterialTypeList?.length == 1 && !PrimaryIdParam) {
  //           //   formik.setFieldValue(
  //           //     `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //           //     response?.MaterialTypeList[0].MaterialTypeIDEncrypted
  //           //   );
  //           // }
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     formik.setFieldValue(`ListOfMaterials[${index}].materialTypeOptions`, []);
  //     formik.setFieldValue(
  //       `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //       ""
  //     );
  //   }
  // };

  // const getMaterialTypeDDL = async (productGroupID, index) => {
  //   if (productGroupID) {
  //     setIsLoading(true);
  //     await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
  //       ProductGroupIDEncrypted: productGroupID,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfMaterials[${index}].materialTypeOptions`,
  //             response?.MaterialTypeList?.map((item) => ({
  //               label: item.MaterialTypeName,
  //               value: item.MaterialTypeIDEncrypted,
  //             }))
  //           );

  //           // /*select the value when there is only one option while insert only*/
  //           // if (response?.MaterialTypeList?.length == 1 && !PrimaryIdParam) {
  //           //   formik.setFieldValue(
  //           //     `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //           //     response?.MaterialTypeList[0].MaterialTypeIDEncrypted
  //           //   );
  //           // }
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     formik.setFieldValue(`ListOfMaterials[${index}].materialTypeOptions`, []);
  //     formik.setFieldValue(
  //       `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //       ""
  //     );
  //   }
  // };

  const getTCNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 5, // 5 = TCNo
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTCNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item?.VoucherSeries,
              value: item?.VoucherSeriesIDEncrypt,
            })),
          );
          // if (InwardNo) {
          //   if (
          //     response?.VoucherSeriesList?.filter(
          //       (x) => x.VoucherSeriesIDEncrypt == InwardNo
          //     )?.length == 0
          //   ) {
          //     formik.setFieldValue("InwardNo", "");
          //   }
          // } else {
          //   /*select the value when there is only one option while insert only*/
          //   if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
          //     formik.setFieldValue(
          //       "InwardNo",
          //       response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
          //     );
          //   }
          // }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectWorkDetailList = async () => {
    // setIsLoading(true);
    post(POST_GetMaterialInwardProjectWorkDetailDDLList, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikWorkDetail.setFieldValue(
            "projectWorkDetailList",
            response?.ProjectWorkDetailDDLList?.map((item) => ({
              WorkDetail: item.ProjectDetails,
              IsSelected: false,
            })),
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // // const getTestDDL = async (
  // //   departmentID,
  // //   productGroupID,
  // //   materialTypeID,
  // //   index
  // // ) => {
  // //   if (departmentID && productGroupID && materialTypeID) {
  // //     setIsLoading(true);
  // //     await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
  // //       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  // //       DepartmentIDEncrypted: departmentID,
  // //       ProductGroupIDEncrypted: productGroupID,
  // //       MaterialTypeIDEncrypted: materialTypeID,
  // //     })
  // //       .then((response) => {
  // //         if (response?.IsSuccess) {
  // //           formik.setFieldValue(
  // //             `ListOfMaterials[${index}].testOptions`,
  // //             response?.List?.map((item) => ({
  // //               label: item?.TestName,
  // //               value: item?.TestMasterIDEncrypted,
  // //             }))
  // //           );
  // //         }
  // //         setIsLoading(false);
  // //       })
  // //       .catch((error) => {
  // //         console.log(error);
  // //         setIsLoading(false);
  // //       });
  // //   } else {
  // //     formik.setFieldValue(`ListOfMaterials[${index}].testOptions`, []);
  // //     formik.setFieldValue(
  // //       `ListOfMaterials[${index}].ListOfMaterialTestDetails`,
  // //       ListOfMaterials[index]?.ListOfMaterialTestDetails?.map((x) => {
  // //         return {
  // //           ...x,
  // //           TestMasterIDEncrypted: "",
  // //           TestMethodIDEncrypted: "",
  // //           ReferenceStandardIDEncrypted: "",
  // //           testMethodOptions: [],
  // //           referenceStandardOptions: [],
  // //         };
  // //       })
  // //     );
  // //   }
  // // };

  // const getTestDDL = async (
  //   departmentID,
  //   productGroupID,
  //   materialTypeID,
  //   mIndex,
  //   tIndex
  // ) => {
  //   if (departmentID && productGroupID && materialTypeID) {
  //     setIsLoading(true);
  //     await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
  //       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //       DepartmentIDEncrypted: departmentID,
  //       ProductGroupIDEncrypted: productGroupID,
  //       MaterialTypeIDEncrypted: materialTypeID,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testOptions`,
  //             response?.List?.map((item) => ({
  //               label: item?.TestName,
  //               value: item?.TestMasterIDEncrypted,
  //             }))
  //           );
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   }
  // };

  const getTestDDL = async (
    departmentID,
    productGroupID,
    materialTypeID,
    mIndex,
    tIndex,
    loaderOff = true,
  ) => {
    if (departmentID) {
      setIsLoading(true);
      await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        DepartmentIDEncrypted: departmentID,
        ProductGroupIDEncrypted: productGroupID,
        MaterialTypeIDEncrypted: materialTypeID,
        TestType: 1, // 0 - All, 1 - DT, 2 - NDT
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testOptions`,
              response?.List?.map((item) => ({
                label: item?.TestName,
                value: item?.TestMasterIDEncrypted,
                IsMixDesign: item?.IsMixDesign,
              })),
            );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getTestMethodDDL_RefStandardDDL_TestDetailsByTest = async (
    testID,
    mIndex,
    tIndex,
    inwardDate,
    setDefault = true,
    loaderOff = true,
  ) => {
    if (testID) {
      // let IsTestAlreadyExist = false;
      //if (setDefault == true) {
      /*check if condition to handle undefine ListOfMaterials While get the data*/
      //   Promise.all(
      //     ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
      //       (x) => x?.IsDeleted == false && x?.IsCancel == false
      //     )?.map((item, idxM) => {
      //       if (item?.TestMasterIDEncrypted === testID && idxM != tIndex) {
      //         IsTestAlreadyExist = true;
      //       }
      //     })
      //   );
      // }

      // if (IsTestAlreadyExist) {
      //   formik.setFieldValue(
      //     `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMasterIDEncrypted`,
      //     ""
      //   );
      //   warningMessage("Selected Test Name already Exist...!");
      //   return;
      // } else {
      setIsLoading(true);
      await post(
        POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
        {
          TestMasterIDEncrypted: testID,
          TranDate: inwardDate
            ? moment(inwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        },
      )
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
              response?.TestMethodList?.map((item) => ({
                label: item?.TestMethod,
                value: item?.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              })),
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
              response?.ReferenceStandardList?.map((item) => ({
                label: item?.ReferenceStandard,
                value: item?.ReferenceStandardIDEncrypted,
                IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
              })),
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
              [
                {
                  label: response?.ProductGroupName,
                  value: response?.ProductGroupIDEncrypted,
                },
              ],
            );
            formik.setFieldValue(
              `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
              response?.MaterialTypeList?.map((item) => ({
                label: item.MaterialTypeName,
                value: item.MaterialTypeIDEncrypted,
              })),
            );

            if (setDefault) {
              if (
                response?.TestMethodList?.length == 1 &&
                response?.TestMethodList[0]?.IsExpiredTestMethod == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestMethodIDEncrypted`,
                  response?.TestMethodList[0]?.TestMethodIDEncrypted,
                );
              }
              if (
                response?.ReferenceStandardList?.length == 1 &&
                response?.ReferenceStandardList[0]
                  ?.IsExpiredReferenceStandard == false
              ) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ReferenceStandardIDEncrypted`,
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                );
                getReferenceStandardTestSubGroupDDL(
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                  testID,
                  mIndex,
                  tIndex,
                );
              }
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].TestCount`,
                response?.DefaultTestCount,
              );
              // formik.setFieldValue(
              //   `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsMachining`,
              //   response?.MachiningRequired
              // );
              formik.setFieldValue(
                `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ProductGroupIDEncrypted`,
                response?.ProductGroupIDEncrypted,
              );
              if (response?.MaterialTypeList?.length == 1) {
                formik.setFieldValue(
                  `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].MaterialTypeIDEncrypted`,
                  response?.MaterialTypeList[0]?.MaterialTypeIDEncrypted,
                );
              }
            }

            // formik.setFieldValue(
            //   `ListOfMaterials[${mIndex}].IsMachining`,
            //   response?.MachiningRequired
            // );
          }
          if (loaderOff == true) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
      // }
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].testMethodOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].referenceStandardOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].refStandardSubGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].productGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].materialTypeOptions`,
        [],
      );
    }
  };

  const getUnitDDL = async () => {
    // setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, //Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item?.CategoryName,
              value: item?.CategoryID,
            })),
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initMaterialTestDetail = {
    InwardMaterialTestDetailIDEncrypted: "",
    DepartmentIDEncrypted: "",
    ProductGroupIDEncrypted: "",
    MaterialTypeIDEncrypted: "",
    TestMasterIDEncrypted: "",
    TestMethodIDEncrypted: "",
    ReferenceStandardIDEncrypted: "",
    RefStandardSubGroup: "",
    TestCount: "",
    BillingQty: AuthUser?.Permissions?.Account === 1 ? "" : 1,
    UnitID: "",
    Rate: "0.00",
    //IsMachining: false,
    TestNote: "",
    productGroupOptions: [],
    materialTypeOptions: [],
    testOptions: [],
    testMethodOptions: [],
    referenceStandardOptions: [],
    refStandardSubGroupOptions: [],
    IsDeleted: false,
    IsCancel: false,
    ListOfTestParameters: [],
    ListOfDefineMoreRates: [],
    IsMixDesign: false,
    TestMixDesignDetail: {
      StipulationsProportioningIDEncrypted: "",
      // InwardIDEncrypted: "",
      // InwardMaterialIDEncrypted: "",
      // InwardMaterialTestDetailIDEncrypted: "",
      // TestMasterIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "",
      TypeofAggregateFineCoarse: "",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
      ListOfMixDesignIncludedTest: [],
    },
    IsMixDesignIncludedTest: false,
    MixDesignTestMasterIDEncrypted: "",
  };

  const initMaterialInformation = {
    TCNoAllocated: false,
    id: "",
    InwardMaterialIDEncrypted: "",
    TCNo: "",
    ULRNo: "",
    // DepartmentIDEncrypted: "",
    // ProductGroupIDEncrypted: "",
    // MaterialTypeIDEncrypted: "",
    Size: "",
    Condition: "",
    SampleDetail: "",
    IsMachining: false,
    ListOfMaterialPhotos: [],
    ListOfMaterialTestDetails: [initMaterialTestDetail],
    // productGroupOptions: [],
    // departmentOptions: [],
    // materialTypeOptions: [],
    // testOptions: [],
    ListOfProcessThicknessDetailsFinal: [],
    //ListOfProcessThicknessDetails: [],
    IsDeleted: false,
    IsHold: false,
  };

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    CustomerProjectIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Project is required field");
        return schema;
      },
    ),
    // ProjectDetails: Yup.string().when(
    //   "btnSubmitType",
    //   ([btnSubmitType], schema) => {
    //     if (btnSubmitType != 1)
    //       return Yup.string().trim().required("Work Detail is required field");
    //     return schema;
    //   }
    // ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, { setSubmitting }) =>
      handleValidSubmit(values, { setSubmitting }),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      InwardNo: "",
      InwardDate: "",
      InwardCurrentStatus: 3,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      ProjectDetails: "",
      LetterRefNo: "",
      StampWriteUpIDEncrypted: "",
      StampImageFilePath: "",
      //MaterialReceiveViaID: "",
      ReceiveRemarks: "",
      //MaterialTakenByUserEncrypted: "",
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      //ReferenceByIDEncrypted: "",
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListOfMaterials: [initMaterialInformation],
      selectedMaterialInfoRow: -1,
      btnSubmitType: 1, // 1 = Draft, 2 = Submit
      IsStampImageFileDeleted: false,
      TestError: "",
      IsTCNoBasedOnInwardNo: true,
      ProjectName: "",
      MaterialReceiveVia: "",
      MaterialTakenByUserName: "",
      ReferenceByName: "",
      ListOfModeDetails: [],
      ListOfReviews: [],
      InwardClubing: false,
      InwardNosClubing: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      InwardDate,
      InwardCurrentStatus,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      ListOfMaterials,
      selectedMaterialInfoRow,
      StampWriteUpIDEncrypted,
      //ReferenceByIDEncrypted,
      ExpectedDateOfDelivery,
      IsTCNoBasedOnInwardNo,
      ListOfModeDetails,
      ListOfReviews,
      InwardClubing,
      InwardNosClubing,
    },
  } = formik;

  const handleValidSubmit = async (values, { setSubmitting }) => {
    setIsLoading(true);

    if (ViewPrimaryIdParam) {
      return;
    }

    if (values?.btnSubmitType == 2) {
      if (ListOfMaterials?.filter((x) => x?.IsDeleted == false)?.length == 0) {
        // warningMessage(
        //   "Material Information is required"
        // );
        formik.setFieldError(
          "ListOfMaterials",
          "Material Information is required",
        );
        formik.setFieldTouched("ListOfMaterials", true);
        setSubmitting(false);
        setIsLoading(false);
        return;
      } else {
        let IsmaterialInfoValid = true;
        let IsTestInfoValid = true;
        let IsTestRequiredValid = true;
        Promise.all(
          ListOfMaterials?.filter((x) => x?.IsDeleted == false)?.map(
            (item, idxM) => {
              if (
                (!item?.TCNo && IsTCNoBasedOnInwardNo == false) ||
                // !item?.DepartmentIDEncrypted ||
                // !item?.ProductGroupIDEncrypted ||
                // !item?.MaterialTypeIDEncrypted ||
                !item?.Size?.trim() ||
                !item?.Condition?.trim() ||
                !item?.SampleDetail?.trim()
              ) {
                IsmaterialInfoValid = false;
              } else {
                if (
                  item?.ListOfMaterialTestDetails?.filter(
                    (x) => x?.IsDeleted == false,
                  )?.length == 0
                ) {
                  IsTestRequiredValid = false;
                } else {
                  Promise.all(
                    item?.ListOfMaterialTestDetails?.filter(
                      (x) => x?.IsDeleted == false,
                    )?.map((test) => {
                      if (
                        !test?.DepartmentIDEncrypted ||
                        // !test?.ProductGroupIDEncrypted ||
                        // !test?.MaterialTypeIDEncrypted ||
                        !test?.TestMasterIDEncrypted ||
                        // !test?.TestMethodIDEncrypted ||
                        //!test?.ReferenceStandardIDEncrypted ||
                        !test?.TestCount ||
                        !test?.BillingQty
                        // ||
                        // !test?.UnitID ||
                        // !test?.Rate ||
                        // !test?.TestNote?.trim()
                      ) {
                        IsTestInfoValid = false;
                      }
                    }),
                  );
                }
              }
            },
          ),
        );
        if (IsmaterialInfoValid == false) {
          // warningMessage(
          //   "Please fill all the details of Material Information..."
          // );
          formik.setFieldError(
            "ListOfMaterials",
            "Please fill all the above details of Material Information...",
          );
          formik.setFieldTouched("ListOfMaterials", true);
          setSubmitting(false);
          setIsLoading(false);
          return;
        }
        if (IsTestRequiredValid == false) {
          // warningMessage("Test Detail is required");
          formik.setFieldError("TestError", "Test Detail is required");
          formik.setFieldTouched("TestError", true);
          setSubmitting(false);
          setIsLoading(false);
          return;
        } else {
          if (IsTestInfoValid == false) {
            // warningMessage(
            //   "Please fill all the details of Test..."
            // );
            formik.setFieldError(
              "TestError",
              "Please fill all the above details of Test...",
            );
            formik.setFieldTouched("TestError", true);
            setSubmitting(false);
            setIsLoading(false);
            return;
          } else {
            if (AuthUser?.Permissions?.Account === 1) {
              let IsBillingQtyValid = true;
              Promise.all(
                ListOfMaterials?.filter((x) => x?.IsDeleted == false)?.map(
                  (item, idxM) => {
                    Promise.all(
                      item?.ListOfMaterialTestDetails?.filter(
                        (x) => x?.IsDeleted == false && x?.IsCancel == false,
                      )?.map((test) => {
                        if (
                          parseInt(test?.TestCount) < parseInt(test?.BillingQty)
                        ) {
                          IsBillingQtyValid = false;
                        }
                      }),
                    );
                  },
                ),
              );
              if (IsBillingQtyValid == false) {
                formik.setFieldError(
                  "ListOfMaterials",
                  "Billing Qty must be less then or equal to Test Count...",
                );
                formik.setFieldTouched("ListOfMaterials", true);
                setSubmitting(false);
                setIsLoading(false);
                return;
              }
            }
          }
        }
      }
    }

    setIsLoading(true);
    let formData = new FormData();
    formData.append("InwardIDEncrypted", values?.InwardIDEncrypt);
    formData.append(
      "InwardDate",
      values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );
    formData.append("InwardCurrentStatus", values?.btnSubmitType == 2 ? 4 : 3);
    formData.append(
      "CustomerProjectIDEncrypted",
      values?.CustomerProjectIDEncrypted,
    );
    formData.append("StampWriteUpIDEncrypted", values?.StampWriteUpIDEncrypted);
    formData.append("StampImageFile", stampImageFile ?? "");
    formData.append("StampImageFilePath", values?.StampImageFilePath);
    formData.append("IsStampImageFileDeleted", values?.IsStampImageFileDeleted);
    formData.append("ProjectDetails", values?.ProjectDetails.trim());
    formData.append("LetterRefNo", values?.LetterRefNo);
    formData.append("IsTPIRequired", values?.IsTPIRequired);

    Promise.all(
      //ListOfLetterRefDoc
      values?.ListOfLetterRefDoc?.map((x, i) => {
        formData.append(
          `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
          x?.InwardLetterRefImageIDEncrypted,
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
          x?.LetterRefImageFile,
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
          x?.LetterRefImageFilePath,
        );
        formData.append(`ListOfLetterRefDoc[${i}].IsDeleted`, x?.IsDeleted);
      }),
    );

    Promise.all(
      //ListOfTPIDetails
      values?.ListOfTPIDetails?.map((x, i) => {
        formData.append(
          `ListOfTPIDetails[${i}].InwardTPIDetailIDEncrypted`,
          x?.InwardTPIDetailIDEncrypted,
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIIDEncrypted`,
          x?.TPIIDEncrypted,
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIContactPersonIDEncrypted`,
          x?.TPIContactPersonIDEncrypted,
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIExpectedDate`,
          x?.TPIExpectedDate
            ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        );
        formData.append(`ListOfTPIDetails[${i}].IsDeleted`, x?.IsDeleted);
      }),
    );

    Promise.all(
      //ListOfMaterials
      values?.ListOfMaterials?.map((x, i) => {
        /* set the id for Material List & it's image list */
        formData.append(`ListOfMaterials[${i}].id`, i + 1);
        formData.append(`ListOfMaterials[${i}].TCNo`, x?.TCNo);
        formData.append(
          `ListOfMaterials[${i}].InwardMaterialIDEncrypted`,
          x?.InwardMaterialIDEncrypted,
        );
        // formData.append(
        //   `ListOfMaterials[${i}].DepartmentIDEncrypted`,
        //   x?.DepartmentIDEncrypted
        // );
        // formData.append(
        //   `ListOfMaterials[${i}].ProductGroupIDEncrypted`,
        //   x?.ProductGroupIDEncrypted
        // );
        // formData.append(
        //   `ListOfMaterials[${i}].MaterialTypeIDEncrypted`,
        //   x?.MaterialTypeIDEncrypted
        // );
        formData.append(`ListOfMaterials[${i}].Size`, x?.Size);
        formData.append(`ListOfMaterials[${i}].Condition`, x?.Condition);
        formData.append(`ListOfMaterials[${i}].SampleDetail`, x?.SampleDetail);

        formData.append(`ListOfMaterials[${i}].IsMachining`, x?.IsMachining);

        formData.append(`ListOfMaterials[${i}].IsDeleted`, x?.IsDeleted);
        formData.append(`ListOfMaterials[${i}].IsHold`, x?.IsHold);

        x?.ListOfMaterialPhotos?.map((y, j) => {
          let photoPath = `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}]`;
          formData.append(`${photoPath}.id`, i + 1);
          formData.append(
            `${photoPath}.InwardMaterialPhotoIDEncrypted`,
            y?.InwardMaterialPhotoIDEncrypted,
          );
          formData.append(
            `${photoPath}.MaterialPhotoFile`,
            y?.MaterialPhotoFile,
          );
          formData.append(
            `${photoPath}.MaterialPhotoFilePath`,
            y?.MaterialPhotoFilePath,
          );
          formData.append(`${photoPath}.IsDeleted`, y?.IsDeleted);
        });

        x?.ListOfMaterialTestDetails?.map((z, k) => {
          const path = `ListOfMaterials[${i}].ListOfTests[${k}]`;
          formData.append(
            `${path}.InwardMaterialTestDetailIDEncrypted`,
            z?.InwardMaterialTestDetailIDEncrypted,
          );
          formData.append(
            `${path}.InwardMaterialIDEncrypted`,
            x?.InwardMaterialIDEncrypted,
          );
          formData.append(`${path}.InwardIDEncrypted`, values?.InwardIDEncrypt);
          formData.append(
            `${path}.DepartmentIDEncrypted`,
            z?.DepartmentIDEncrypted,
          );
          formData.append(
            `${path}.ProductGroupIDEncrypted`,
            z?.ProductGroupIDEncrypted,
          );
          formData.append(
            `${path}.MaterialTypeIDEncrypted`,
            z?.MaterialTypeIDEncrypted,
          );
          formData.append(
            `${path}.TestMasterIDEncrypted`,
            z?.TestMasterIDEncrypted,
          );
          formData.append(
            `${path}.TestMethodIDEncrypted`,
            z?.TestMethodIDEncrypted,
          );
          formData.append(
            `${path}.ReferenceStandardIDEncrypted`,
            z?.ReferenceStandardIDEncrypted,
          );
          formData.append(
            `${path}.RefStandardSubGroup`,
            z?.RefStandardSubGroup,
          );
          formData.append(`${path}.TestCount`, z?.TestCount);
          formData.append(
            `${path}.BillingQty`,
            AuthUser?.Permissions?.Account === 1 ? z?.BillingQty : 1,
          );
          formData.append(`${path}.UnitID`, z?.UnitID);
          formData.append(`${path}.Rate`, z?.Rate?.toString());
          // formData.append(
          //   `${path}.IsMachining`,
          //   z.IsMachining
          // );
          formData.append(`${path}.TestNote`, z?.TestNote);
          formData.append(`${path}.IsDeleted`, z?.IsDeleted);

          formData.append(`${path}.IsMixDesign`, z?.IsMixDesign);
          formData.append(
            `${path}.StipulationsProportioningIDEncrypted`,
            z?.TestMixDesignDetail?.StipulationsProportioningIDEncrypted,
          );
          formData.append(
            `${path}.TypeofCementIDEncrypted`,
            z?.TestMixDesignDetail?.TypeofCementIDEncrypted,
          );
          formData.append(
            `${path}.TypeofMineralAdmixtureIDEncrypted`,
            z?.TestMixDesignDetail?.TypeofMineralAdmixtureIDEncrypted,
          );
          formData.append(
            `${path}.MaximumNominalSizeofAggregateIDEncrypted`,
            z?.TestMixDesignDetail?.MaximumNominalSizeofAggregateIDEncrypted,
          );
          formData.append(
            `${path}.EnvironmentalExposureConditionsIDEncrypted`,
            z?.TestMixDesignDetail?.EnvironmentalExposureConditionsIDEncrypted,
          );
          formData.append(
            `${path}.TypeofAggregateFineIDEncrypted`,
            z?.TestMixDesignDetail?.TypeofAggregateFineIDEncrypted,
          );
          formData.append(
            `${path}.ChemicalAdmixtureTypeIDEncrypted`,
            z?.TestMixDesignDetail?.ChemicalAdmixtureTypeIDEncrypted,
          );
          formData.append(
            `${path}.ChemicalAdmixtureBrandBatchandMarkIDEncrypted`,
            z?.TestMixDesignDetail
              ?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
          );
          formData.append(
            `${path}.GradeDesignation`,
            z?.TestMixDesignDetail?.GradeDesignation,
          );
          formData.append(
            `${path}.MinimumCementContent`,
            z?.TestMixDesignDetail?.MinimumCementContent
              ? z?.TestMixDesignDetail?.MinimumCementContent.toString()
              : "",
          );
          formData.append(
            `${path}.MaximumCementContent`,
            z?.TestMixDesignDetail?.MaximumCementContent
              ? z?.TestMixDesignDetail?.MaximumCementContent.toString()
              : "",
          );
          formData.append(
            `${path}.MaximumWaterCementRatio`,
            z?.TestMixDesignDetail?.MaximumWaterCementRatio
              ? z?.TestMixDesignDetail?.MaximumWaterCementRatio.toString()
              : "",
          );
          formData.append(
            `${path}.Workability`,
            z?.TestMixDesignDetail?.Workability,
          );
          formData.append(
            `${path}.RetentionTime`,
            z?.TestMixDesignDetail?.RetentionTime,
          );
          formData.append(
            `${path}.TransportationTime`,
            z?.TestMixDesignDetail?.TransportationTime,
          );
          formData.append(
            `${path}.DegreeofSiteControl`,
            z?.TestMixDesignDetail?.DegreeofSiteControl,
          );
          formData.append(
            `${path}.TypeofAggregateFineCoarse`,
            z?.TestMixDesignDetail?.TypeofAggregateFineCoarse,
          );
          formData.append(
            `${path}.MethodofConcretePlacingIsChute_NonPumpable`,
            z?.TestMixDesignDetail?.MethodofConcretePlacingIsChute_NonPumpable,
          );
          formData.append(
            `${path}.MethodofConcretePlacingIsPumping`,
            z?.TestMixDesignDetail?.MethodofConcretePlacingIsPumping,
          );
          formData.append(
            `${path}.IsMixDesignIncludedTest`,
            z?.IsMixDesignIncludedTest,
          );
          formData.append(
            `${path}.MixDesignTestMasterIDEncrypted`,
            z?.MixDesignTestMasterIDEncrypted,
          );

          z?.ListOfTestParameters?.filter((x) => x.IsSelected == true)?.map(
            (para, paraIndex) => {
              const paraPath = `ListOfMaterials[${i}].ListOfTests[${k}].ListOfParameters[${paraIndex}]`;
              formData.append(
                `${paraPath}.InwardMaterialTestDetailIDEncrypted`,
                para?.InwardMaterialTestDetailIDEncrypted,
              );
              formData.append(
                `${paraPath}.TestMasterIDEncrypted`,
                para?.TestMasterIDEncrypted,
              );
              formData.append(
                `${paraPath}.RefParameterIDEncrypted`,
                para?.RefParameterIDEncrypted,
              );
              formData.append(`${paraPath}.ParameterType`, para?.ParameterType);
            },
          );

          z?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)?.map(
            (para, paraIndex) => {
              const paraPath = `ListOfMaterials[${i}].ListOfTests[${k}].ListOfDefineMoreRates[${paraIndex}]`;
              formData.append(
                `${paraPath}.InwardMaterialTestDetailIDEncrypted`,
                para?.InwardMaterialTestDetailIDEncrypted,
              );
              formData.append(
                `${paraPath}.TestMasterIDEncrypted`,
                para?.TestMasterIDEncrypted,
              );

              formData.append(`${paraPath}.RateType`, para?.RateType);
            },
          );
        });

        x?.ListOfProcessThicknessDetailsFinal?.map((y, j) => {
          const processPath = `ListOfMaterials[${i}].ListOfProcessThicknessDetailsFinal[${j}]`;
          formData.append(
            `${processPath}.InwardMachiningDetailIDEncrypted`,
            y?.InwardMachiningDetailIDEncrypted,
          );

          formData.append(
            `${processPath}.InwardMaterialIDEncrypted`,
            x?.InwardMaterialIDEncrypted,
          );

          formData.append(
            `${processPath}.InwardIDEncrypted`,
            values?.InwardIDEncrypt,
          );

          formData.append(
            `${processPath}.MachiningConfigurationIDEncrypted`,
            y?.MachiningConfigurationIDEncrypted,
          );
          formData.append(`${processPath}.MachiningNote`, y?.MachiningNote);
          formData.append(`${processPath}.Qty`, y?.Qty);
          formData.append(`${processPath}.Length`, y?.Length);
          formData.append(`${processPath}.VendorRate`, y?.VendorRate);
          formData.append(`${processPath}.InvoiceRate`, y?.InvoiceRate);
          formData.append(`${processPath}.Thickness`, y?.Thickness);
          formData.append(`${processPath}.IsDeleted`, y?.IsDeleted);
        });
      }),
    );

    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    console.log("formData", ListOfMaterials);
    //return;

    await postFormData(POST_TCAllocationSave, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate(-1);
            // if (FormTypeParam == 1) {
            //   navigate("/tc-test-allocation-list");
            // } else {
            //   navigate("/material-inward");
            // }
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
          setSubmitting(false);
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam || ViewPrimaryIdParam) {
      // if (document.body.getAttribute("data-sidebar-style") == "full") {
      //   document.querySelector("#main-wrapper").classList.add("menu-toggle");
      //   document.querySelector(".hamburger").classList.add("is-active");
      // }
      setIsLoading(true);
      getCustomerDDL();
      //getDepartmentDDL();
      // getProductGroupDDL();
      getUnitDDL();
      getTCAllocationDetailByID();
      getProcessNameDDL();
    } else {
      navigate(-1);
    }
  }, []);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getProjectDDL();
    }
  }, [CustomerIDEncrypted]);

  useEffect(() => {
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      //formik.setFieldValue("StampWriteUpIDEncrypted", "");
      //formik.setFieldValue("ReferenceByIDEncrypted", "");
      getStampWriteUpDDL();
      getProjectWorkDetailList();
    } else {
      setStampWriteUpOptions([]);
      formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);
    }
  }, [CustomerProjectIDEncrypted]);

  useEffect(() => {
    if (InwardDate) {
      getTCNoDDL();
      getDepartmentDDL();
    }
  }, [InwardDate]);

  const getTCAllocationDetailByID = async () => {
    setIsLoading(true);
    await post(POST_GetTCAllocationDetail, {
      InwardIDEncrypted: ViewPrimaryIdParam
        ? window.atob(ViewPrimaryIdParam)
        : window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            InwardIDEncrypt: response?.InwardIDEncrypted,
            // InwardDate: response?.InwardDate
            //   ? new Date(response?.InwardDate)
            //   : "",
            InwardDate: response?.InwardDate,
            InwardClubing: response?.IsInwardNoClubing,
            InwardNosClubing: response?.InwardNosClubing,
            // ExpectedDateOfDelivery: response?.ExpectedDateOfDelivery
            //   ? new Date(response?.ExpectedDateOfDelivery)
            //   : "",
            ExpectedDateOfDelivery: response?.ExpectedDateOfDelivery,
            ListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => {
              return {
                ...x,
                LetterRefImageFile: "",
                viewFile: "",
                LetterRefImageFileName: x?.LetterRefImageFileName,
                // LetterRefImageFileName: x?.LetterRefImageFilePath
                //   ? (x?.LetterRefImageFilePath?.split("/"))[
                //       x?.LetterRefImageFilePath?.split("/").length - 1
                //     ]
                //   : "",
                IsDeleted: false,
              };
            }),
            ListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
              return {
                ...x,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            }),
            ListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                ListOfMaterialTestDetails:
                  x?.ListOfTests?.length > 0
                    ? x?.ListOfTests?.map((t) => {
                        return {
                          ...t,
                          // productGroupOptions: [], //get the options through api
                          // materialTypeOptions: [], //get the options through api
                          // testOptions: [], //get the options through api
                          // testMethodOptions: [], //get the options through api
                          // referenceStandardOptions: [], //get the options through api
                          productGroupOptions: t?.ProductGroupDDLOptions?.map(
                            (opt) => ({
                              label: opt?.ProductGroupName,
                              value: opt?.ProductGroupIDEncrypted,
                            }),
                          ),
                          materialTypeOptions: t?.MaterialTypeDDLOptions?.map(
                            (opt) => ({
                              label: opt.MaterialTypeName,
                              value: opt.MaterialTypeIDEncrypted,
                            }),
                          ),
                          testOptions: t?.TestMasterDDLOptions?.map((opt) => ({
                            label: opt?.TestName,
                            value: opt?.TestMasterIDEncrypted,
                            IsMixDesign: opt?.IsMixDesign,
                          })),
                          testMethodOptions: [],
                          referenceStandardOptions:
                            t?.ReferenceStandardDDLOptions?.map((opt) => ({
                              label: opt?.ReferenceStandard,
                              value: opt?.ReferenceStandardIDEncrypted,
                              IsExpiredReferenceStandard:
                                opt?.IsExpiredReferenceStandard,
                            })),
                          refStandardSubGroupOptions:
                            t?.RefStandardSubGroupOptions?.map((opt) => ({
                              label: opt?.SubGroup,
                              value: opt?.SubGroup,
                            })),
                          IsDeleted: false,
                          ListOfTestParameters:
                            t?.ListOfTestParameters?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfTestParameters
                              : t?.ListOfTestParameters?.map((para) => ({
                                  ...para,
                                  IsSelected: true,
                                })),
                          ListOfDefineMoreRates:
                            t?.ListOfDefineMoreRates?.filter(
                              (x) => x.IsSelected == true,
                            )?.length > 0
                              ? t?.ListOfDefineMoreRates
                              : t?.ListOfDefineMoreRates?.map((para) => ({
                                  ...para,
                                  IsSelected: para.IsSelected,
                                })),
                        };
                      })
                    : response?.InwardCurrentStatus == 2
                      ? [initMaterialTestDetail]
                      : [],

                ListOfProcessThicknessDetailsFinal:
                  x.ListOfMachiningDetails?.map((t) => {
                    return {
                      ...t,
                      IsDeleted: false,
                    };
                  }),
                //ListOfProcessThicknessDetails: [],

                // productGroupOptions: [], //get the options through api
                // departmentOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                // testOptions: [], //get the options through api
                IsDeleted: false,
              };
            }),
            selectedMaterialInfoRow: -1,
            btnSubmitType: 1, // 1 = Draft, 2 = Submit
            IsStampImageFileDeleted: false,
          });

          /*Below code commented b'coz ddl options get with details api response */
          // response?.ListOfMaterials?.map((item, index) => {
          //   // getProductGroupDDL(item.DepartmentIDEncrypted, index);
          //   // getMaterialTypeDDL(
          //   //   item?.DepartmentIDEncrypted,
          //   //   item?.ProductGroupIDEncrypted,
          //   //   index
          //   // );
          //   // getMaterialTypeDDL(item?.ProductGroupIDEncrypted, index);
          //   // getTestDDL(
          //   //   item?.DepartmentIDEncrypted,
          //   //   item?.ProductGroupIDEncrypted,
          //   //   item?.MaterialTypeIDEncrypted,
          //   //   index
          //   // );
          //   // getDepartmentDDL(item?.ProductGroupIDEncrypted, index);
          //   Promise.all(
          //     item?.ListOfTests?.map((test, tIdx) => {
          //       // getProductGroupDDL(test?.DepartmentIDEncrypted, index, tIdx);
          //       // getTestDDL(
          //       //   test?.DepartmentIDEncrypted,
          //       //   item?.ProductGroupIDEncrypted,
          //       //   item?.MaterialTypeIDEncrypted,
          //       //   index,
          //       //   tIdx
          //       // );
          //       getTestDDL(
          //         test?.DepartmentIDEncrypted,
          //         test?.ProductGroupIDEncrypted,
          //         test?.MaterialTypeIDEncrypted,
          //         index,
          //         tIdx,
          //         false
          //       );
          //       getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
          //         test?.TestMasterIDEncrypted,
          //         index,
          //         tIdx,
          //         response?.InwardDate,
          //         false,
          //         false
          //       );
          //     })
          //   );
          // });
          if (response?.StampImageFilePath) {
            setStampImage(response?.StampImageFilePath);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    //console.log("ListOfMaterials", ListOfMaterials);
  };

  const uploadStampImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setStampImageFile(null);
        setStampImage(null);
        warningMessage("Select valid image file!");
      } else {
        // var reader = new FileReader();
        // reader.readAsDataURL(e.target.files[0]);
        // reader.onload = function (e) {
        //   var image = new Image();
        //   image.src = e.target.result;
        //   image.onload = function () {
        //     var height = this.height;
        //     var width = this.width;
        // if (height !== 200 || width !== 200) {
        //   swal("Error!", "Image size must be of 200x200", "error");
        //   setStampImageFile(null);
        //   setStampImage(null);
        // } else {
        setStampImageFile(file);
        setStampImage(URL.createObjectURL(file));
        // }
        //   };
        // };
      }
      //formik.setFieldValue("StampImageFilePath", "");
    }
  };

  const uploadLetterRefDoc = (e) => {
    if (e?.target?.files[0]) {
      const file = e.target.files[0];
      //console.log(file);
      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i),
      );
    }
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field",
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (values) => {
    if (values?.editIndexTPI !== "") {
      if (
        ListOfTPIDetails?.filter(
          (x, i) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false &&
            i != values?.editIndexTPI,
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.map((x, idx) => {
            if (idx == values?.editIndexTPI) {
              return {
                ...x,
                TPIIDEncrypted: values?.TPIIDEncrypted,
                TPIContactPersonIDEncrypted:
                  values?.TPIContactPersonIDEncrypted,
                TPIExpectedDate: values?.TPIExpectedDate,
                TPIName: values?.TPIName,
                TPIContactPersonName: values?.TPIContactPersonName,
                displayTPIExpectedDate: values?.TPIExpectedDate
                  ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                  : "",
              };
            } else {
              return { ...x };
            }
          }),
        );
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false,
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            ...values,
            displayTPIExpectedDate: values?.TPIExpectedDate
              ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
          },
        ]);
      }
    }
    setShowAddTPIDetailModal(false);
  };

  const addNewTPI = () => {
    if (CustomerProjectIDEncrypted) {
      formikTPIDetail.resetForm();
      /*select the value when there is only one option while insert only*/
      if (tpiCustomerOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIIDEncrypted",
          tpiCustomerOptions[0].value,
        );
        formikTPIDetail.setFieldValue("TPIName", tpiCustomerOptions[0].label);
      }
      /*select the value when there is only one option while insert only*/
      if (tpiContactPersonOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIContactPersonIDEncrypted",
          tpiContactPersonOptions[0].value,
        );
        formikTPIDetail.setFieldValue(
          "TPIContactPersonName",
          tpiContactPersonOptions[0].label,
        );
      }
      setShowAddTPIDetailModal(true);
    } else {
      warningMessage("Please select Project first...");
    }
  };

  const editTPI = (i) => {
    let editData = ListOfTPIDetails[i];
    formikTPIDetail.setValues({ ...editData, editIndexTPI: i });
    formikTPIDetail.setFieldValue("actionFlagTPI", 1); // 1 = edit
    setShowAddTPIDetailModal(true);
  };

  const deleteTPI = (i) => {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i),
      );
    }
  };

  const AddNewMaterialInformation = () => {
    formik.setFieldValue("ListOfMaterials", [
      ...ListOfMaterials,
      initMaterialInformation,
    ]);

    // /*select the value when there is only one option while insert only*/
    // if (departmentOptions?.length == 1 && !PrimaryIdParam) {
    //   let newIndex = ListOfMaterials?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${newIndex}].DepartmentIDEncrypted`,
    //     departmentOptions[0].value
    //   );
    //   getProductGroupDDL(departmentOptions[0].value, newIndex);
    // }

    /*select the value when there is only one option while insert only*/
    if (productGroupOptions?.length == 1 && !PrimaryIdParam) {
      let newIndex = ListOfMaterials?.length;
      formik.setFieldValue(
        `ListOfMaterials[${newIndex}].ProductGroupIDEncrypted`,
        productGroupOptions[0].value,
      );
    }
  };

  const deleteMaterialInformation = (i) => {
    if (ListOfMaterials[i]?.InwardMaterialIDEncrypted) {
      formik.setFieldValue(`ListOfMaterials[${i}].IsDeleted`, true);
      formik.setFieldValue(
        `ListOfMaterials[${i}].ListOfMaterialPhotos`,
        ListOfMaterials[i]?.ListOfMaterialPhotos?.map((x) => {
          return { ...x, IsDeleted: true };
        }),
      );
      formik.setFieldValue(
        `ListOfMaterials[${i}].ListOfMaterialTestDetails`,
        ListOfMaterials[i]?.ListOfMaterialTestDetails?.map((x) => {
          return { ...x, IsDeleted: true };
        }),
      );
    } else {
      formik.setFieldValue(
        "ListOfMaterials",
        ListOfMaterials?.filter((x, idx) => idx != i),
      );
    }
  };

  const validationMaterialInfoRepeatRow = Yup.object().shape({
    NoOfRepeatMaterialInfoRow: Yup.number()
      .min(1, "No of Repeat Row is required field")
      .required("No of Repeat Row is required field"),
  });

  const formikMaterialInfoRepeatRow = useFormik({
    validationSchema: validationMaterialInfoRepeatRow,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMaterialInfoRepeatRow(values, formikHelpers),
    initialValues: {
      NoOfRepeatMaterialInfoRow: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikMaterialInfoRepeatRow;

  const handleValidSubmitMaterialInfoRepeatRow = (values) => {
    setIsLoading(true);
    setTimeout(() => {
      let selectedRow = ListOfMaterials[selectedMaterialInfoRow];
      let newListOfMaterials = ListOfMaterials;
      // for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
      //   newListOfMaterials = [...newListOfMaterials, selectedRow];
      // }
      for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
        newListOfMaterials = [
          ...newListOfMaterials,
          {
            ...selectedRow,
            id: "",
            TCNo: "",
            TCNoAllocated: false,
            InwardMaterialIDEncrypted: "",
            ULRNo: "",
            ListOfMaterialTestDetails:
              selectedRow?.ListOfMaterialTestDetails?.map((x) => {
                return {
                  ...x,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: x?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                };
              }) ?? [],
          },
        ];
      }
      formik.setFieldValue("ListOfMaterials", newListOfMaterials);
      setShowMaterialInfoRepeatRowQtyModal(false);
      setIsLoading(false);
    }, 300);
  };

  const [showTestDetailsRepeatModal, setShowTestDetailsRepeatModal] =
    useState(false);

  const validationTestDetailsRepeat = Yup.object().shape({});

  const formikTestDetailsRepeat = useFormik({
    validationSchema: validationTestDetailsRepeat,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestDetailsRepeat(values, formikHelpers),
    initialValues: {
      repeatTestDetailsProductGroupID: "",
      repeatTestDetailsProductGroupName: "",
      repeatTestDetailsMaterialTypeID: "",
      repeatTestDetailsMaterialTypeName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      repeatTestDetailsProductGroupID,
      repeatTestDetailsProductGroupName,
      repeatTestDetailsMaterialTypeID,
      repeatTestDetailsMaterialTypeName,
    },
  } = formikTestDetailsRepeat;

  const openRepeatTestDetailsModel = (selectedIndex) => {
    // let selectedRow = ListOfMaterials[selectedIndex];
    // if (
    //   selectedRow?.ProductGroupIDEncrypted &&
    //   selectedRow?.MaterialTypeIDEncrypted
    // ) {
    //   var selectedProductGroupName =
    //     productGroupOptions?.filter(
    //       (x) => x.value == selectedRow?.ProductGroupIDEncrypted
    //     )[0]?.label ?? "";
    //   var selectedMaterialTypeName =
    //     selectedRow?.materialTypeOptions?.filter(
    //       (x) => x.value == selectedRow?.MaterialTypeIDEncrypted
    //     )[0]?.label ?? "";

    //   formikTestDetailsRepeat.setFieldValue(
    //     "repeatTestDetailsProductGroupID",
    //     selectedRow?.ProductGroupIDEncrypted
    //   );
    //   formikTestDetailsRepeat.setFieldValue(
    //     "repeatTestDetailsMaterialTypeID",
    //     selectedRow?.MaterialTypeIDEncrypted
    //   );
    //   formikTestDetailsRepeat.setFieldValue(
    //     "repeatTestDetailsProductGroupName",
    //     selectedProductGroupName
    //   );
    //   formikTestDetailsRepeat.setFieldValue(
    //     "repeatTestDetailsMaterialTypeName",
    //     selectedMaterialTypeName
    //   );
    //   setShowTestDetailsRepeatModal(true);
    // } else {
    //   warningMessage("Please select Material Group and Material Type...");
    // }

    setShowTestDetailsRepeatModal(true);
  };

  const handleValidSubmitTestDetailsRepeat = (values) => {
    setIsLoading(true);
    let selectedTestDetails = ListOfMaterials[
      selectedMaterialInfoRow
    ]?.ListOfMaterialTestDetails?.filter(
      (x) => x.IsDeleted == false && x.IsCancel == false,
    );

    formik.setFieldValue(
      "ListOfMaterials",
      ListOfMaterials?.map((x, i) => {
        if (
          selectedMaterialInfoRow != i &&
          // &&
          // repeatTestDetailsProductGroupID == x?.ProductGroupIDEncrypted &&
          // repeatTestDetailsMaterialTypeID == x?.MaterialTypeIDEncrypted
          x?.IsHold == false
        ) {
          return {
            ...x,
            ListOfMaterialTestDetails: [
              ...x?.ListOfMaterialTestDetails?.map((e) => {
                return { ...e, IsDeleted: true };
              }),
              ...selectedTestDetails?.map((t) => {
                return {
                  ...t,
                  InwardMaterialTestDetailIDEncrypted: "",
                  ListOfTestParameters: t?.ListOfTestParameters?.map((y) => {
                    return { ...y, InwardMaterialTestDetailIDEncrypted: "" };
                  }),
                };
              }),
            ],
          };
        } else {
          return { ...x };
        }
      }),
    );

    setShowTestDetailsRepeatModal(false);
    setIsLoading(false);
  };

  const [materialPhoto, setMaterialPhoto] = useState(null);
  const [materialPhotoFile, setMaterialPhotoFile] = useState(null);

  const [fileKeyMaterialPhoto, setFileKeyMaterialPhoto] = useState();

  const [zoomMaterialPhoto, setZoomMaterialPhoto] = useState(0.5);

  const [openCropperModalMaterialPhoto, setOpenCropperModalMaterialPhoto] =
    useState(false);
  const [openWebCamModalMaterialImage, setOpenWebCamModalMaterialImage] =
    useState(false);
  const [imageMaterialPhoto, setImageMaterialPhoto] = useState();
  const [cropperMaterialPhoto, setCropperMaterialPhoto] = useState();

  const getCropDataMaterialPhoto = () => {
    if (typeof cropperMaterialPhoto !== "undefined") {
      handleUploadMaterialPhoto(
        cropperMaterialPhoto.getCroppedCanvas().toDataURL(),
      );
      setMaterialPhoto(cropperMaterialPhoto.getCroppedCanvas().toDataURL());
    }
  };

  const handleUploadMaterialPhoto = async (url) => {
    const outputFileMaterialPhoto = await dataUrlToFileUsingFetch(
      url,
      "output.png",
      "image/png",
    );
    //const file = dataUrlToFile(url, "output.png");
    setMaterialPhotoFile(outputFileMaterialPhoto);
  };

  const uploadMaterialPhoto = (event) => {
    if (event?.target?.files?.length === 1) {
      var pattern = /image-*/;
      if (event.target.files[0].type.match(pattern)) {
        event.preventDefault();
        let files;
        if (event.dataTransfer) {
          files = event.dataTransfer.files;
        } else if (event.target) {
          files = event.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setImageMaterialPhoto(reader.result);
        };
        reader.readAsDataURL(files[0]);
        setOpenCropperModalMaterialPhoto(true);
      } else {
        setMaterialPhotoFile(null);
        setMaterialPhoto(null);
        warningMessage("Select valid image file!");
      }
    }
  };

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setMaterialPhoto(imageSrc);
      const outputFileMaterialPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png",
      );
      setMaterialPhotoFile(outputFileMaterialPhotoCapture);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalMaterialImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  const addMaterialImage = () => {
    //console.log(ListOfMaterials[selectedMaterialInfoRow]);
    formik.setFieldValue(
      `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
      [
        ...ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos,
        {
          id: "",
          InwardMaterialPhotoIDEncrypted: "",
          viewFile: URL.createObjectURL(materialPhotoFile),
          MaterialPhotoFile: materialPhotoFile,
          MaterialPhotoFilePath: "",
          IsDeleted: false,
        },
      ],
    );
    setMaterialPhoto(null);
    setMaterialPhotoFile(null);
  };

  const deleteMaterialImage = (i) => {
    if (
      ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos[i]
        ?.InwardMaterialPhotoIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos[${i}].IsDeleted`,
        true,
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
        ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos?.filter(
          (x, idx) => idx != i,
        ),
      );
    }
  };

  const AddNewMaterialTestInformation = (index) => {
    formik.setFieldValue(
      `ListOfMaterials[${index}].ListOfMaterialTestDetails`,
      [
        ...ListOfMaterials[index].ListOfMaterialTestDetails,
        initMaterialTestDetail,
      ],
    );

    // /*select the value when there is only one option while insert only*/
    // if (ListOfMaterials[index]?.testOptions?.length == 1) {
    //   let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].TestMasterIDEncrypted`,
    //     ListOfMaterials[index]?.testOptions[0].value
    //   );
    //   getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
    //     ListOfMaterials[index]?.testOptions[0].value,
    //     index,
    //     newIndex
    //   );
    // }

    /*select the value when there is only one option while insert only*/
    if (ListOfMaterials[index]?.departmentOptions?.length == 1) {
      let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].DepartmentIDEncrypted`,
        ListOfMaterials[index]?.departmentOptions[0].value,
      );
      // getTestDDL(
      //   ListOfMaterials[index]?.departmentOptions[0].value,
      //   ListOfMaterials[index]?.ProductGroupIDEncrypted,
      //   ListOfMaterials[index]?.MaterialTypeIDEncrypted,
      //   index,
      //   newIndex
      // );
      getTestDDL(
        ListOfMaterials[index]?.departmentOptions[0].value,
        "",
        "",
        index,
        newIndex,
      );
    }
    /*select the value when there is only one option while insert only*/
    if (unitOptions?.length == 1) {
      let newIndex = ListOfMaterials[index].ListOfMaterialTestDetails?.length;
      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfMaterialTestDetails[${newIndex}].UnitID`,
        unitOptions[0].value,
      );
    }
  };

  const deleteMaterialTestInformation = (mIndex, tIndex) => {
    if (
      ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex].IsMixDesign ==
        true &&
      ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
        .TestMasterIDEncrypted
    ) {
      deleteMixDesignIncludedTest(
        mIndex,
        ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
          .TestMasterIDEncrypted,
        true,
      );
    } else {
      if (
        ListOfMaterials[mIndex]?.InwardMaterialIDEncrypted &&
        ListOfMaterials[mIndex]?.ListOfMaterialTestDetails[tIndex]
          ?.InwardMaterialTestDetailIDEncrypted
      ) {
        formik.setFieldValue(
          `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].IsDeleted`,
          true,
        );
      } else {
        formik.setFieldValue(
          `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails`,
          ListOfMaterials[mIndex]?.ListOfMaterialTestDetails?.filter(
            (x, idx) => idx != tIndex,
          ),
        );
      }
    }
  };

  const formikWorkDetail = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWorkDetail(values, formikHelpers),
    initialValues: {
      projectWorkDetailList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { projectWorkDetailList },
  } = formikWorkDetail;

  const handleValidSubmitWorkDetail = (values) => {
    formik.setFieldValue(
      "ProjectDetails",
      values?.projectWorkDetailList
        ?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.WorkDetail;
        })
        .join(" "),
    );
    setShowWorkDetailModal(false);
  };

  const getProcessNameDDL = async () => {
    // setIsLoading(true);
    await post(POST_GetMachiningProcessDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProcessNameOptions(
            response?.List?.map((item) => ({
              label: item?.ProcessName,
              value: item?.MachiningConfigurationIDEncrypted,
              RateMatrix: item?.RateMatrix,
              VendorRate: item?.VendorRate,
              InvoiceRate: item?.InvoiceRate,
              //RateMatrixList: item.ListOfRateMatrix,
            })),
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initProcessThicknessDetails = {
    InwardMachiningDetailIDEncrypted: "",
    InwardMaterialIDEncrypted: "",
    InwardIDEncrypted: "",
    MachiningConfigurationIDEncrypted: "",
    MachiningNote: "",
    Qty: "",
    Length: "",
    Thickness: "",
    VendorRate: "",
    InvoiceRate: "",
    IsDeleted: false,
  };

  const validationMaterialProcessDetailSchema = Yup.object().shape({});

  const formikMaterialProcessDetail = useFormik({
    validationMaterialProcessDetailSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidMaterialProcessSubmit(values, formikHelpers),
    initialValues: {
      MaterialListIndex: -1,
      ListOfProcessThicknessDetails: [initProcessThicknessDetails],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfProcessThicknessDetails },
  } = formikMaterialProcessDetail;

  const handleValidMaterialProcessSubmit = (values) => {
    formik.setFieldValue(
      `ListOfMaterials[${values.MaterialListIndex}].ListOfProcessThicknessDetailsFinal`,
      values?.ListOfProcessThicknessDetails?.filter(
        (x, ix) => ix?.MachiningConfigurationIDEncrypted != "",
      ),
    );

    setShowMaterialProcessModal(false);
  };

  const getMaterialProcessDetails = (index, valueChecked, id) => {
    //alert(index);
    if (valueChecked == true) {
      formikMaterialProcessDetail.setFieldValue("MaterialListIndex", index);

      let newListOneRecord = ListOfMaterials[
        index
      ].ListOfProcessThicknessDetailsFinal?.filter(
        (x) => x.IsDeleted == false,
      )?.map((item, idx) => {
        if (item?.MachiningConfigurationIDEncrypted == "") {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return {
            ...item,
            IsDeleted: false,
          };
        }
      });

      formikMaterialProcessDetail.setFieldValue(
        "ListOfProcessThicknessDetails",
        [
          // ...ListOfMaterials[index].ListOfProcessThicknessDetailsFinal,
          ...newListOneRecord,
          initProcessThicknessDetails,
        ],
      );

      setShowMaterialProcessModal(true);
    } else {
      setShowMaterialProcessModal(false);

      let newList = ListOfProcessThicknessDetails?.filter(
        (x) => x.IsDeleted == false,
      )?.map((item, idx) => {
        if (item?.InwardMachiningDetailIDEncrypted == "") {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return {
            ...item,
            IsDeleted: false,
          };
        }
      });

      formikMaterialProcessDetail.setFieldValue(
        "ListOfProcessThicknessDetails",
        [],
      );

      formik.setFieldValue(
        `ListOfMaterials[${index}].ListOfProcessThicknessDetailsFinal`,
        newList,
      );
    }
  };

  const addNewProcess = (indxTest) => {
    formikMaterialProcessDetail.setFieldValue(`ListOfProcessThicknessDetails`, [
      ...ListOfProcessThicknessDetails,
      initProcessThicknessDetails,
    ]);
  };

  const removeProcess = (indxTest) => {
    let newList = ListOfProcessThicknessDetails?.filter(
      (x) => x?.IsDeleted == false,
    )?.map((item, idx) => {
      if (indxTest == idx) {
        return {
          ...item,
          IsDeleted: true,
        };
      } else {
        return { ...item };
      }
    });

    formikMaterialProcessDetail.setFieldValue(
      `ListOfProcessThicknessDetails`,
      newList,
    );
  };

  const checkValidationProcess = (id, index) => {
    ListOfProcessThicknessDetails?.filter((x) => x.IsDeleted == false)?.map(
      (x) => {
        if (x?.MachiningConfigurationIDEncrypted == id) {
          warningMessage("Process Already Exist!");

          formikMaterialProcessDetail.setFieldValue(
            `ListOfProcessThicknessDetails[${index}].MachiningConfigurationIDEncrypted`,
            "",
          );
          return;
        }
      },
    );
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png",
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const getInwardMaterialTestParametersList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex,
  ) => {
    setIsLoading(true);
    await post(POST_GetTestParametersList, {
      TestMasterIDEncrypted: testMasterID,
      CustomerIDEncrypted: CustomerIDEncrypted,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfTestParameters`,
            response?.ParametersList?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ParametersList
              : response?.ParametersList?.map((para) => ({
                  ...para,
                  IsSelected: true,
                })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersTestName: "",
      ParametersList: [],
      materialIndexPara: 0,
      testIndexPara: 0,
      selectAllPara: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { ParametersTestName, ParametersList, selectAllPara },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    formik.setFieldValue(
      `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfTestParameters`,
      values?.ParametersList,
    );
    setShowTestParametersModal(false);
  };

  const handleChangeSelectAllPara = (isChecked) => {
    formikTestPrameters.setFieldValue("selectAllPara", isChecked);
    formikTestPrameters.setFieldValue(
      "ParametersList",
      ParametersList?.map((x) => {
        return { ...x, IsSelected: isChecked };
      }),
    );
  };

  /*START: List Material handle events */
  const handleChangeIsMachining = (indx, e, item) => {
    if (item?.IsHold == false) {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].IsMachining`,
        !item?.IsMachining,
      );

      formikMaterialProcessDetail.setFieldValue("MaterialListIndex", indx);

      getMaterialProcessDetails(
        indx,
        e.target.checked,
        item?.InwardMaterialIDEncrypted,
      );
    }
  };

  const handleOnClickMaterialInfoImages = (indx, item) => {
    if (item?.IsHold == false) {
      setShowMaterialInfoImagesModal(true);
      formik.setFieldValue("selectedMaterialInfoRow", indx);
      setMaterialPhotoFile(null);
      setMaterialPhoto(null);
    }
  };

  const handleOnClickRepeatTestDetails = (indx) => {
    formik.setFieldValue("selectedMaterialInfoRow", indx);
    formikTestDetailsRepeat.resetForm();
    openRepeatTestDetailsModel(indx);
  };

  const handleChangeDepartment = (indx, indxTest, e) => {
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    let itemTest = ListOfMaterials[indx].ListOfMaterialTestDetails[indxTest];
    let mixDesignTest = false;
    if (itemTest.IsMixDesign == true) {
      mixDesignTest = true;
      setSelectedTCIndex(indx);
      setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    }

    formik.setFieldValue(`${path}.DepartmentIDEncrypted`, e?.value ?? "");
    formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
    formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
    formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
    formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
    formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
    formik.setFieldValue(`${path}.testOptions`, []);
    formik.setFieldValue(`${path}.testMethodOptions`, []);
    formik.setFieldValue(`${path}.referenceStandardOptions`, []);
    formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
    formik.setFieldValue(`${path}.productGroupOptions`, []);
    formik.setFieldValue(`${path}.materialTypeOptions`, []);
    formik.setFieldValue(`${path}.ListOfTestParameters`, []);
    formik.setFieldValue(`${path}.IsMixDesign`, false);
    formik.setFieldValue(
      `${path}.TestMixDesignDetail`,
      initMaterialTestDetail.TestMixDesignDetail,
    );
    // getProductGroupDDL(
    //  e?.value ?? "",
    //   indx,
    //   indxTest
    // );
    getTestDDL(e?.value ?? "", "", "", indx, indxTest);

    if (mixDesignTest == true) {
      setDeleteMixDesignIncludedTestActionStatus(true);
    }
  };

  const handleChangeTestMaster = (indx, indxTest, e, itemTest) => {
    let IsTestAlreadyExist = false;
    const path = `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}]`;
    let mixDesignTest = false;
    if (itemTest.IsMixDesign == true) {
      mixDesignTest = true;
      setSelectedTCIndex(indx);
      setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    }

    if (e && e?.value) {
      if (e?.value !== itemTest?.TestMasterIDEncrypted) {
        Promise.all(
          ListOfMaterials[indx]?.ListOfMaterialTestDetails?.filter(
            (x) => x?.IsDeleted == false && x?.IsCancel == false,
          )?.map((item, idxM) => {
            if (item?.TestMasterIDEncrypted === e?.value && idxM != indxTest) {
              IsTestAlreadyExist = true;
            }
          }),
        );

        formik.setFieldValue(`${path}.ListOfTestParameters`, []);
        formik.setFieldValue(`${path}.IsMixDesign`, false);
        formik.setFieldValue(
          `${path}.TestMixDesignDetail`,
          initMaterialTestDetail.TestMixDesignDetail,
        );
        formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
        formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
        formik.setFieldValue(`${path}.referenceStandardOptions`, []);
        formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
        formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
        formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
        formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
        if (IsTestAlreadyExist) {
          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
          warningMessage("Selected Test Name already Exist...!");
          //return;
        } else {
          formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");
          if (e?.IsMixDesign == true) {
            formikMixDesignTestDetails.resetForm();
            formikMixDesignTestDetails.setFieldValue(
              "MixDesignTestName",
              e?.label,
            );
            formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
            formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
            getMixDesignMasterDDLAll(e?.value ?? "");
            setShowMixDesignTestDetailModal(true);
          }
          formik.setFieldValue(`${path}.IsMixDesign`, e?.IsMixDesign);
          getInwardMaterialTestParametersList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest,
          );
          getInwardMaterialDefineMoreRatesList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest,
          );
          getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
            e?.value ?? "",
            indx,
            indxTest,
            InwardDate,
          );
        }
      }
    } else {
      formik.setFieldValue(`${path}.ListOfTestParameters`, []);
      formik.setFieldValue(`${path}.IsMixDesign`, false);
      formik.setFieldValue(
        `${path}.TestMixDesignDetail`,
        initMaterialTestDetail.TestMixDesignDetail,
      );
      formik.setFieldValue(`${path}.TestMasterIDEncrypted`, e?.value ?? "");
      formik.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
      formik.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
      formik.setFieldValue(`${path}.referenceStandardOptions`, []);
      formik.setFieldValue(`${path}.RefStandardSubGroup`, "");
      formik.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
      formik.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
      formik.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    }

    if (mixDesignTest == true) {
      setDeleteMixDesignIncludedTestActionStatus(true);
    }
  };

  const handleOnClickParameterSelection = (indx, indxTest, item, itemTest) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikTestPrameters.setFieldValue(
        "ParametersTestName",
        itemTest?.testOptions?.filter(
          (x) => x?.value == itemTest?.TestMasterIDEncrypted,
        )[0]?.label,
      );
      formikTestPrameters.setFieldValue(
        "ParametersList",
        itemTest?.ListOfTestParameters,
      );
      formikTestPrameters.setFieldValue("materialIndexPara", indx);
      formikTestPrameters.setFieldValue("testIndexPara", indxTest);
      formikTestPrameters.setFieldValue(
        "selectAllPara",
        itemTest?.ListOfTestParameters?.filter((x) => x.IsSelected == false)
          ?.length > 0
          ? false
          : true,
      );
      setShowTestParametersModal(true);
    }
  };

  const handleChangeReferenceStandard = (testMasterID, indx, indxTest, e) => {
    if (e?.IsExpiredReferenceStandard == true) {
      warningMessage("Reference Standard is Expired..!");
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`,
        e?.value ?? "",
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
        [],
      );
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
        "",
      );
      getReferenceStandardTestSubGroupDDL(
        e?.value ?? "",
        testMasterID,
        indx,
        indxTest,
      );
    }
  };

  const getReferenceStandardTestSubGroupDDL = async (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
  ) => {
    setIsLoading(true);
    await post(POST_GetReferenceStandardTestSubGroupDDL, {
      ReferenceStandardIDEncrypted: referenceStandardID,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
            response?.SubGroupList?.map((item) => ({
              label: item?.SubGroup,
              value: item?.SubGroup,
            })),
          );
          /*select the value when there is only one option*/
          if (response?.SubGroupList?.length == 1) {
            formik.setFieldValue(
              `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
              response?.SubGroupList[0].SubGroup,
            );
            getParameterPreferenceBasedOnRefStandardTestMap(
              response?.SubGroupList[0].SubGroup,
              referenceStandardID,
              testMasterID,
              indx,
              indxTest,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterPreferenceBasedOnRefStandardTestMap = async (
    refStandardSubGroup,
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
  ) => {
    if (
      AuthUser?.Permissions?.ParameterPreferenceLoadBasedOnRefStandardTestMap ==
      true
    ) {
      setIsLoading(true);
      await post(
        POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
          RefStandardSubGroup: refStandardSubGroup,
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CustomerIDEncrypted: CustomerIDEncrypted,
          InwardMaterialTestDetailIDEncrypted:
            ListOfMaterials[indx]?.ListOfMaterialTestDetails[indxTest]
              .InwardMaterialTestDetailIDEncrypted,
        },
      )
        .then((response) => {
          if (response?.IsSuccess) {
            /* set the list if any of the parameters is selected from the list based on preference */
            if (
              response?.ParametersList?.filter((x) => x.IsSelected == true)
                ?.length > 0
            ) {
              formik.setFieldValue(
                `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ListOfTestParameters`,
                response?.ParametersList,
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleChangeRefStandardSubGroup = (
    referenceStandardID,
    testMasterID,
    indx,
    indxTest,
    e,
  ) => {
    formik.setFieldValue(
      `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
      e?.value ?? "",
    );
    getParameterPreferenceBasedOnRefStandardTestMap(
      e?.value ?? "",
      referenceStandardID,
      testMasterID,
      indx,
      indxTest,
    );
  };

  const handleChangeTestCount = (indx, indxTest, e) => {
    if (e?.target?.value < 1000) {
      formik.setFieldValue(
        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestCount`,
        e?.target?.value ?? "",
      );
    }
  };
  /*END: List Material handle events */

  const [showMixDesignTestDetailModal, setShowMixDesignTestDetailModal] =
    useState(false);

  const validationMixDesignTestDetail = Yup.object().shape({
    GradeDesignation: Yup.string().required(
      "Grade Designation is required field",
    ),
  });

  const formikMixDesignTestDetails = useFormik({
    validationSchema: validationMixDesignTestDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMixDesignTestDetail(values, formikHelpers),
    initialValues: {
      MixDesignTestName: "",
      StipulationsProportioningIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "450",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "Good",
      TypeofAggregateFineCoarse: "Crushed angular aggregate",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
      optionsTypeOfCement: [],
      optionsTypeOfMineralAdmixture: [],
      optionsMaximumNominalSizeofAggregate: [],
      optionsEnvironmentralExposureConditions: [],
      optionsTypeOfAggregateFine: [],
      optionsChemicalAdmixtureType: [],
      optionsChemicalAdmixtureBrandBatchMarkId: [],
      ListOfMixDesignIncludedTest: [],
      tcIndex: 0,
      testIndex: 0,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MixDesignTestName,
      optionsTypeOfCement,
      optionsTypeOfMineralAdmixture,
      optionsMaximumNominalSizeofAggregate,
      optionsEnvironmentralExposureConditions,
      optionsTypeOfAggregateFine,
      optionsChemicalAdmixtureType,
      optionsChemicalAdmixtureBrandBatchMarkId,
      MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping,
      ListOfMixDesignIncludedTest,
    },
  } = formikMixDesignTestDetails;

  const [mixDesignTestAddingAction, setMixDesignTestAddingAction] =
    useState(false);
  const [countOfNewAddedIncludedTest, setCountOfNewAddedIncludedTest] =
    useState(0);

  useEffect(() => {
    if (mixDesignTestAddingAction == true) {
      let totalTests =
        ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
          .ListOfMaterialTestDetails.length;
      if (countOfNewAddedIncludedTest > 0) {
        let startIndex = totalTests - countOfNewAddedIncludedTest;
        let endIndex = startIndex + countOfNewAddedIncludedTest - 1;

        if (startIndex > 0) {
          for (let i = startIndex; i <= endIndex; i++) {
            getInwardMaterialTestParametersList(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i,
            );

            getInwardMaterialDefineMoreRatesList(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i,
            );
            getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
              ListOfMaterials[formikMixDesignTestDetails.values.tcIndex]
                .ListOfMaterialTestDetails[i]?.TestMasterIDEncrypted,
              formikMixDesignTestDetails.values.tcIndex,
              i,
              InwardDate,
            );
          }
        }
      }
      setMixDesignTestAddingAction(false);
    }
  }, [mixDesignTestAddingAction]);

  const handleValidSubmitMixDesignTestDetail = (values) => {
    let existingListOfMaterialTestDetails =
      ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails;

    existingListOfMaterialTestDetails[values.testIndex].TestMixDesignDetail = {
      StipulationsProportioningIDEncrypted:
        values?.StipulationsProportioningIDEncrypted,
      TypeofCementIDEncrypted: values?.TypeofCementIDEncrypted,
      TypeofMineralAdmixtureIDEncrypted:
        values?.TypeofMineralAdmixtureIDEncrypted,
      MaximumNominalSizeofAggregateIDEncrypted:
        values?.MaximumNominalSizeofAggregateIDEncrypted,
      EnvironmentalExposureConditionsIDEncrypted:
        values?.EnvironmentalExposureConditionsIDEncrypted,
      TypeofAggregateFineIDEncrypted: values?.TypeofAggregateFineIDEncrypted,
      ChemicalAdmixtureTypeIDEncrypted:
        values?.ChemicalAdmixtureTypeIDEncrypted,
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted:
        values?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
      GradeDesignation: values?.GradeDesignation,
      MinimumCementContent: values?.MinimumCementContent
        ? values?.MinimumCementContent.toString()
        : "",
      MaximumCementContent: values?.MaximumCementContent
        ? values?.MaximumCementContent.toString()
        : "",
      MaximumWaterCementRatio: values?.MaximumWaterCementRatio
        ? values?.MaximumWaterCementRatio.toString()
        : "",
      Workability: values?.Workability,
      RetentionTime:
        values?.RetentionTime != ""
          ? moment(values?.RetentionTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      TransportationTime:
        values?.TransportationTime != ""
          ? moment(values?.TransportationTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      DegreeofSiteControl: values?.DegreeofSiteControl,
      TypeofAggregateFineCoarse: values?.TypeofAggregateFineCoarse,
      MethodofConcretePlacingIsChute_NonPumpable:
        values?.MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping:
        values?.MethodofConcretePlacingIsPumping,
    };

    let includedTestTobeAddList = [];
    values?.ListOfMixDesignIncludedTest?.map((x) => {
      if (
        ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails.filter(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            test.IsDeleted == false &&
            test.IsCancel == false,
        ).length == 0
      ) {
        includedTestTobeAddList.push({
          ...initMaterialTestDetail,
          DepartmentIDEncrypted:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].DepartmentIDEncrypted,
          testOptions:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].testOptions,
          TestMasterIDEncrypted: x.TestMasterIDEncrypted,
          IsMixDesignIncludedTest: true,
          MixDesignTestMasterIDEncrypted:
            ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
              values.testIndex
            ].TestMasterIDEncrypted,
        });
      } else {
        let testIndexExisting = ListOfMaterials[
          values.tcIndex
        ].ListOfMaterialTestDetails.findIndex(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            test.IsDeleted == false &&
            test.IsCancel == false,
        );
        existingListOfMaterialTestDetails[
          testIndexExisting
        ].IsMixDesignIncludedTest = true;
        existingListOfMaterialTestDetails[
          testIndexExisting
        ].MixDesignTestMasterIDEncrypted =
          ListOfMaterials[values.tcIndex].ListOfMaterialTestDetails[
            values.testIndex
          ].TestMasterIDEncrypted;
      }
    });

    setCountOfNewAddedIncludedTest(includedTestTobeAddList.length);
    if (includedTestTobeAddList.length > 0) {
      formik.setFieldValue(
        `ListOfMaterials[${values.tcIndex}].ListOfMaterialTestDetails`,
        [...existingListOfMaterialTestDetails, ...includedTestTobeAddList],
      );
      setMixDesignTestAddingAction(true);
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${values.tcIndex}].ListOfMaterialTestDetails`,
        existingListOfMaterialTestDetails,
      );
    }
    setShowMixDesignTestDetailModal(false);
  };

  const getMixDesignMasterDDLAll = async (testMasterID) => {
    setIsLoading(true);
    await post(POST_GetMixDesignMasterDropDownListAll, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfCement",
            response.TypeofCementList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfMineralAdmixture",
            response.TypeofMineralAdmixtureList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsMaximumNominalSizeofAggregate",
            response.MaximumNominalSizeofAggregateList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsEnvironmentralExposureConditions",
            response.EnvironmentalExposureConditionsList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfAggregateFine",
            response.TypeofAggregateFineList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureType",
            response.ChemicalAdmixtureTypeList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureBrandBatchMarkId",
            response.ChemicalAdmixtureBrandBatchandIDMarkList,
          );
          formikMixDesignTestDetails.setFieldValue(
            "ListOfMixDesignIncludedTest",
            response.ListOfMixDesignIncludedTest,
          );
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickMixDesignDetail = (indx, indxTest, item, itemTest) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikMixDesignTestDetails.resetForm();
      let testName = itemTest?.testOptions.filter(
        (x) => x.value == itemTest.TestMasterIDEncrypted,
      )[0]?.label;
      let mdDetail = itemTest?.TestMixDesignDetail;
      formikMixDesignTestDetails.setFieldValue("MixDesignTestName", testName);
      formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
      formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
      formikMixDesignTestDetails.setFieldValue(
        "StipulationsProportioningIDEncrypted",
        mdDetail?.StipulationsProportioningIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofCementIDEncrypted",
        mdDetail?.TypeofCementIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofMineralAdmixtureIDEncrypted",
        mdDetail?.TypeofMineralAdmixtureIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumNominalSizeofAggregateIDEncrypted",
        mdDetail?.MaximumNominalSizeofAggregateIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "EnvironmentalExposureConditionsIDEncrypted",
        mdDetail?.EnvironmentalExposureConditionsIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofAggregateFineIDEncrypted",
        mdDetail?.TypeofAggregateFineIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "ChemicalAdmixtureTypeIDEncrypted",
        mdDetail?.ChemicalAdmixtureTypeIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "ChemicalAdmixtureBrandBatchandMarkIDEncrypted",
        mdDetail?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
      );
      formikMixDesignTestDetails.setFieldValue(
        "GradeDesignation",
        mdDetail?.GradeDesignation,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MinimumCementContent",
        mdDetail?.MinimumCementContent,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumCementContent",
        mdDetail?.MaximumCementContent == ""
          ? "450"
          : mdDetail?.MaximumCementContent,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MaximumWaterCementRatio",
        mdDetail?.MaximumWaterCementRatio,
      );
      formikMixDesignTestDetails.setFieldValue(
        "Workability",
        mdDetail?.Workability,
      );
      formikMixDesignTestDetails.setFieldValue(
        "RetentionTime",
        mdDetail?.RetentionTime != ""
          ? convertTimeToDateTime(mdDetail?.RetentionTime)
          : "",
      );
      formikMixDesignTestDetails.setFieldValue(
        "TransportationTime",
        mdDetail?.TransportationTime != ""
          ? convertTimeToDateTime(mdDetail?.TransportationTime)
          : "",
      );
      formikMixDesignTestDetails.setFieldValue(
        "DegreeofSiteControl",
        mdDetail?.DegreeofSiteControl == ""
          ? "Good"
          : mdDetail?.DegreeofSiteControl,
      );
      formikMixDesignTestDetails.setFieldValue(
        "TypeofAggregateFineCoarse",
        mdDetail?.TypeofAggregateFineCoarse == ""
          ? "Crushed angular aggregate"
          : mdDetail?.TypeofAggregateFineCoarse,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MethodofConcretePlacingIsChute_NonPumpable",
        mdDetail?.MethodofConcretePlacingIsChute_NonPumpable,
      );
      formikMixDesignTestDetails.setFieldValue(
        "MethodofConcretePlacingIsPumping",
        mdDetail?.MethodofConcretePlacingIsPumping,
      );
      getMixDesignMasterDDLAll(itemTest.TestMasterIDEncrypted);
      setShowMixDesignTestDetailModal(true);
    }
  };

  const [selectedTCIndex, setSelectedTCIndex] = useState(-1);
  const [selectedMixDesignTestID, setSelectedMixDesignTestID] = useState("");
  const [
    deleteMixDesignIncludedTestActionStatus,
    setDeleteMixDesignIncludedTestActionStatus,
  ] = useState(false);

  useEffect(() => {
    if (deleteMixDesignIncludedTestActionStatus == true) {
      deleteMixDesignIncludedTest(selectedTCIndex, selectedMixDesignTestID);
      setDeleteMixDesignIncludedTestActionStatus(false);
    }
  }, [deleteMixDesignIncludedTestActionStatus]);

  const deleteMixDesignIncludedTest = (
    mIndex,
    mixDesignTestID,
    deleteMixDesignTestAlso = false,
  ) => {
    let newListOfMaterialTestDetails = [];
    Promise.all(
      ListOfMaterials[mIndex].ListOfMaterialTestDetails?.map((test, tIx) => {
        if (
          ListOfMaterials[mIndex]?.InwardMaterialIDEncrypted &&
          test?.InwardMaterialTestDetailIDEncrypted
        ) {
          if (test.MixDesignTestMasterIDEncrypted == mixDesignTestID) {
            newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
          } else {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == true) {
                newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
              } else {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        } else {
          if (test.MixDesignTestMasterIDEncrypted != mixDesignTestID) {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == false) {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        }
      }),
    );

    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails`,
      newListOfMaterialTestDetails,
    );
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getInwardMaterialDefineMoreRatesList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex,
  ) => {
    setIsLoading(true);
    await post(POST_GetTestWiseDefineMoreRatesList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CustomerIDEncrypted: CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            `ListOfMaterials[${mIndex}].ListOfMaterialTestDetails[${tIndex}].ListOfDefineMoreRates`,
            response?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ListOfDefineMoreRates
              : response?.ListOfDefineMoreRates?.map((para) => ({
                  ...para,
                  IsSelected: para?.IsSelected,
                })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickDefineMoreRatesSelection = async (
    indx,
    indxTest,
    item,
    itemTest,
    testmasterid,
    TestDetailID,
  ) => {
    if (itemTest?.IsCancel == false && item?.IsHold == false) {
      formikDefineMoreRates.setFieldValue(
        "MoreTestRatesList",
        itemTest?.ListOfDefineMoreRates,
      );

      formikDefineMoreRates.setFieldValue("materialIndexPara", indx);
      formikDefineMoreRates.setFieldValue("testIndexPara", indxTest);
      formikDefineMoreRates.setFieldValue("testmasterid", testmasterid);
      formikDefineMoreRates.setFieldValue("TestDetailID", TestDetailID);

      setShowDefineMoreRatesModal(true);
    }
    // setIsLoading(true);
    // await post(POST_GetTestWiseDefineMoreRatesList, {
    //   CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    //   TestMasterIDEncrypted: testmasterid,
    //   InwardMaterialTestDetailIDEncrypted: TestDetailID,
    //   CustomerIDEncrypted: CustomerIDEncrypted,
    // })
    //   .then((response) => {
    //     if (response?.IsSuccess) {
    //       formikDefineMoreRates.setFieldValue(
    //         "MoreTestRatesList",
    //         response?.ListOfDefineMoreRates
    //       );

    //       formikDefineMoreRates.setFieldValue("materialIndexPara", indx);
    //       formikDefineMoreRates.setFieldValue("testIndexPara", indxTest);

    //       formikDefineMoreRates.setFieldValue("testmasterid", testmasterid);
    //       formikDefineMoreRates.setFieldValue("TestDetailID", TestDetailID);

    //       // formik.setFieldValue(
    //       //   `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ListOfDefineMoreRates`,
    //       //   response?.ListOfDefineMoreRates?.map((itemsubRate) => ({
    //       //     InwardMaterialTestDetailIDEncrypted: TestDetailID,
    //       //     TestMasterIDEncrypted: testmasterid,
    //       //     RateType: itemsubRate?.RateType,
    //       //     RateTypeName: itemsubRate?.RateTypeName,
    //       //     IsSelected: itemsubRate?.IsSelected,
    //       //   }))
    //       // );

    //       setShowDefineMoreRatesModal(true);
    //     } else {
    //       errorMessage(response?.Message);
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setIsLoading(false);
    //   });
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
      materialIndexPara: 0,
      testIndexPara: 0,
      FristtimeClickbtn: false,
      testmasterid: "",
      TestDetailID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    formik.setFieldValue(
      `ListOfMaterials[${values?.materialIndexPara}].ListOfMaterialTestDetails[${values?.testIndexPara}].ListOfDefineMoreRates`,
      values?.MoreTestRatesList?.map((itemsubRate) => ({
        InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
        TestMasterIDEncrypted: values?.testmasterid,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
      })),
    );
    setShowDefineMoreRatesModal(false);
  };

  // For Pagination
  const PAGE_SIZE_OPTIONS = [20, 30, 50, 100];

  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(0);

  const filteredMaterials = React.useMemo(() => {
    return ListOfMaterials?.filter((x) => x.IsDeleted === false) ?? [];
  }, [ListOfMaterials]);

  // const totalPages = Math.ceil(filteredMaterials.length / pageSize);
  const totalPages = React.useMemo(() => {
    if (ViewPrimaryIdParam) {
      setPageSize(filteredMaterials.length);
    }
    return Math.ceil(filteredMaterials.length / pageSize);
  }, [filteredMaterials.length]);

  const pagedMaterials = React.useMemo(() => {
    // setIsLoading(true);
    const start = page * pageSize;
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 300);
    return filteredMaterials.slice(start, start + pageSize);
  }, [filteredMaterials, page, pageSize]);

  React.useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [page, pageSize]);

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {ViewPrimaryIdParam
                ? "View Material Inward"
                : "TC / Test Allocation"}
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <label>Inward Info:</label> &nbsp; {CustomerName}
                  </Col>
                  <Col lg={3}>
                    <label>Inward No:</label> &nbsp; {InwardNo}
                  </Col>
                  <Col lg={3}>
                    <label>Inward Date:</label> &nbsp; {InwardDate}
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={9}>
                    <Row>
                      <Col lg={4}>
                        <Field
                          label="Project"
                          name="CustomerProjectIDEncrypted"
                          placeholder={"Select Project"}
                          options={projectOptions}
                          component={CustomSelect}
                          required
                          autoFocus
                          isDisabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Stamp"
                          name="StampWriteUpIDEncrypted"
                          placeholder={"Select Stamp"}
                          options={stampWriteUpOptions}
                          component={CustomSelect}
                          isDisabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={4}>
                        {/* <Field
                          label="Letter Ref No"
                          name="LetterRefNo"
                          placeholder={"Enter Letter Ref No"}
                          component={CustomInput}
                          maxLength={100}
                          disabled={ViewPrimaryIdParam}
                        /> */}
                        <CustomInputUncontrolled
                          label="Letter Ref No"
                          name={`LetterRefNo`}
                          placeholder={"Enter Letter Ref No"}
                          defaultValue={formik.values.LetterRefNo}
                          maxLength={100}
                          noMarginBottom={true}
                          disabled={ViewPrimaryIdParam}
                          onValueCommit={(val) => {
                            formik.setFieldValue(`LetterRefNo`, val);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={8}>
                        {!ViewPrimaryIdParam ? (
                          <Link
                            to="#"
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="Select Work Detail"
                            style={{ float: "right" }}
                            onClick={() => {
                              setShowWorkDetailModal(true);
                            }}
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        ) : (
                          ""
                        )}
                        {/* <Field
                          label="Work Detail"
                          name="ProjectDetails"
                          placeholder={"Enter Work Detail"}
                          component={CustomTextArea}
                          rows={5}
                          // required
                          maxLength={2000}
                          disabled={ViewPrimaryIdParam}
                        /> */}
                        <CustomTextAreaUncontrolled
                          label="Work Detail"
                          name="ProjectDetails"
                          placeholder={"Enter Work Detail"}
                          defaultValue={formik.values.ProjectDetails}
                          disabled={ViewPrimaryIdParam}
                          maxLength={2000}
                          rows={5}
                          onValueCommit={(val) => {
                            formik.setFieldValue("ProjectDetails", val);
                          }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Row>
                          <Col lg={12}>
                            <label className="mb-1">Letter Ref Doc</label>
                            <div className="mb-2">
                              <div className="input-group">
                                <span className="form-control form-control-sm ps-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    onClick={() => {
                                      setShowLetterRefDocModal(true);
                                    }}
                                  >
                                    View Letter Ref Doc
                                  </Link>
                                </span>
                                <div
                                  className="input-group-text"
                                  title="Choose File"
                                  style={{
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                  }}
                                >
                                  <div className="open-file">
                                    <input
                                      //type="file"
                                      id="LetterRefUpload"
                                      // //accept="image/png, image/gif, image/jpeg"
                                      // onChange={uploadLetterRefDoc}
                                      onClick={() => {
                                        setShowLetterRefDocModal(true);
                                      }}
                                    />
                                    <label
                                      htmlFor="LetterRefUpload"
                                      name=""
                                    ></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div className="d-flex">
                              <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                                <label className="mb-1">
                                  TPI Required &nbsp;
                                </label>
                              </text>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckIsTPIRequired"
                                  title={IsTPIRequired == true ? "Yes" : "No"}
                                  checked={IsTPIRequired}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      "IsTPIRequired",
                                      !IsTPIRequired,
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                  disabled={ViewPrimaryIdParam}
                                ></input>
                              </div>
                            </div>
                            {IsTPIRequired == true && (
                              <div className="mb-2">
                                <div className="input-group">
                                  <span className="form-control form-control-sm ps-2">
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      onClick={() => {
                                        setShowTPIDetailModal(true);
                                      }}
                                    >
                                      View TPI Details
                                    </Link>
                                  </span>
                                  <div
                                    className="input-group-text"
                                    title="Add TPI Detail"
                                    style={{
                                      borderRadius: "0 0.375rem 0.375rem 0",
                                      cursor: ViewPrimaryIdParam
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                    onClick={() => {
                                      if (!ViewPrimaryIdParam) {
                                        addNewTPI();
                                      }
                                    }}
                                  >
                                    <i className="fa fa-plus" />
                                  </div>
                                </div>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {ViewPrimaryIdParam ? (
                      AuthUser?.Permissions?.InwardClubing == true ? (
                        <Row>
                          {CustomerIDEncrypted ? (
                            <>
                              <Col lg={6}>
                                <div className="d-flex">
                                  <div className="pt-2">
                                    <label className="mb-1"></label>
                                    <div className="d-flex mb-2">
                                      <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                                        <label className="mb-1">
                                          Inward Clubing &nbsp;
                                        </label>
                                      </text>

                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          id="flexSwitchCheckInwardClubing"
                                          title={
                                            InwardClubing == true ? "Yes" : "No"
                                          }
                                          checked={InwardClubing}
                                          style={{ cursor: "pointer" }}
                                          disabled={ViewPrimaryIdParam}
                                        ></input>
                                      </div>
                                    </div>
                                  </div>
                                  &nbsp;&nbsp;&nbsp;
                                  {InwardClubing ? (
                                    <div style={{ flex: 1 }}>
                                      {/* <Field
                                        label="Clubing Inward No"
                                        name="InwardNosClubing"
                                        placeholder={"Inward No"}
                                        component={CustomInput}
                                        disabled={ViewPrimaryIdParam}
                                      /> */}
                                      <CustomInputUncontrolled
                                        label="Clubing Inward No"
                                        name="InwardNosClubing"
                                        placeholder={"Inward No"}
                                        defaultValue={
                                          formik.values.InwardNosClubing
                                        }
                                        disabled={ViewPrimaryIdParam}
                                        onValueCommit={(val) => {
                                          formik.setFieldValue(
                                            `InwardNosClubing`,
                                            val,
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </Col>
                            </>
                          ) : (
                            ""
                          )}
                        </Row>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col lg={3}>
                    <Row>
                      <Col lg={12}>
                        <div className="mb-2">
                          {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                            <>
                              <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                <label className="mb-1">
                                  Sample Returnable:
                                </label>{" "}
                                &nbsp;{" "}
                                {IsMaterialReturnable == true ? "Yes" : "No"}
                              </text>
                              <br></br>
                            </>
                          ) : (
                            ""
                          )}
                          <label className="mb-1 mt-2">
                            Expected Delivery Date:
                          </label>
                          &nbsp; {ExpectedDateOfDelivery}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <label className="mb-1">
                          Stamp Image
                          {/* <span className="text-danger">*</span>*/}
                          {/* {" "} <span className="text-danger fs-12">(200 x 200)</span> */}
                        </label>
                        <div className="image-placeholder square-placeholder">
                          {!ViewPrimaryIdParam ? (
                            <>
                              <div className="avatar-edit">
                                <input
                                  type="file"
                                  id="imageUpload"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={uploadStampImage}
                                />
                                <label htmlFor="imageUpload" name=""></label>
                              </div>
                              <div
                                id="removeFile"
                                className="avatar-delete"
                                onClick={() => {
                                  setStampImageFile(null);
                                  setStampImage(null);
                                  //formik.setFieldValue("StampImageFilePath", "");
                                  formik.setFieldValue(
                                    "IsStampImageFileDeleted",
                                    true,
                                  );
                                }}
                              >
                                <label htmlFor="removeFile" name=""></label>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          <div className="avatar-preview">
                            <div id="imagePreview">
                              <img
                                id="saveImageFile"
                                src={stampImage ? stampImage : img200}
                                alt={"Stamp Image"}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="mt-0 mb-1"></hr>
                <Row>
                  <label>Material Information</label>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="MaterialInfo-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="MaterialInfo-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="2%">
                                {!ViewPrimaryIdParam ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md bg-primary-light"
                                    title="Add New"
                                    onClick={() => {
                                      AddNewMaterialInformation();
                                    }}
                                  >
                                    <i className="fa fa-plus"></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </th>
                              <th width="12%">TC No</th>
                              {/* <th width="13%">Department</th> */}
                              {/* <th width="15%">Material Group</th>
                              <th width="15%">Material Type</th> */}
                              {/* <th width="11%">Size</th>
                              <th width="13%">Condition</th>
                              <th width="21%">Sample Detail</th> */}
                              <th width="35%">Sample Detail</th>
                              <th width="20%">Condition</th>
                              <th width="20%">Size</th>
                              {AuthUser?.Permissions?.Machining == 1 ? (
                                <th width="7%">Machining</th>
                              ) : (
                                ""
                              )}
                              <th width="4%" style={{ textAlign: "left" }}>
                                Images
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {pagedMaterials?.filter((x) => x.IsDeleted == false)
                              ?.length > 0 ? (
                              pagedMaterials?.map((item, indxx) => {
                                const indx = page * pageSize + indxx;
                                return (
                                  <React.Fragment key={`material_${indx}`}>
                                    <tr
                                      key={`tc_${indx}`}
                                      style={{
                                        display:
                                          item.IsDeleted == true ? "none" : "",
                                      }}
                                    >
                                      <td
                                        className="p-1"
                                        style={{
                                          borderBottomColor: "transparent",
                                        }}
                                      >
                                        {item?.IsHold == true ? (
                                          <>
                                            <OverlayTrigger
                                              trigger={["hover", "focus"]}
                                              key={`tip_${indx}`}
                                              responsive={true}
                                              overlay={
                                                <Tooltip className="toltip-popover">
                                                  <strong className="p-1">
                                                    <label>Hold:</label>{" "}
                                                    {item?.HoldReason}
                                                  </strong>
                                                </Tooltip>
                                              }
                                            >
                                              <span>
                                                <i
                                                  className="fa fa-info-circle ms-2"
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "#9698ab",
                                                  }}
                                                ></i>
                                              </span>
                                            </OverlayTrigger>
                                          </>
                                        ) : !ViewPrimaryIdParam ? (
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-danger-light me-1"
                                            className="icon-box icon-box-md"
                                            title="Delete"
                                            onClick={() => {
                                              //deleteMaterialInformation(indx);
                                              delete_RecordWithoutApi(
                                                deleteMaterialInformation,
                                                indx,
                                              );
                                            }}
                                            disabled={
                                              ViewPrimaryIdParam ? true : false
                                            }
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        ) : (
                                          ""
                                        )}

                                        {/* <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light ms-1"
                                        className="icon-box icon-box-md"
                                        title="Repeat"
                                        onClick={() => {
                                          formik.setFieldValue(
                                            "selectedMaterialInfoRow",
                                            indx
                                          );
                                          formikMaterialInfoRepeatRow.resetForm();
                                          setShowMaterialInfoRepeatRowQtyModal(
                                            true
                                          );
                                        }}
                                      >
                                        <i className="fa fa-repeat" />
                                      </Link> */}
                                      </td>

                                      {/* <td
                                      className="p-1"
                                      style={{ minWidth: "140px" }}
                                    >
                                      {(InwardCurrentStatus == 2 &&
                                        item.TCNoAllocated == false) ||
                                      (InwardCurrentStatus == 3 &&
                                        item.TCNoAllocated == false) ||
                                      !item.InwardMaterialIDEncrypted ? (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          options={tcNoOptions}
                                          component={CustomSelect}
                                          maxLength={100}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                        />
                                      ) : (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          component={CustomInput}
                                          disabled={true}
                                          noMarginBottom={true}
                                        />
                                      )}
                                    </td> */}
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "140px" }}
                                      >
                                        {((InwardCurrentStatus == 2 &&
                                          item.TCNoAllocated == false) ||
                                          (InwardCurrentStatus == 3 &&
                                            item.TCNoAllocated == false) ||
                                          !item.InwardMaterialIDEncrypted) &&
                                        IsTCNoBasedOnInwardNo == false ? (
                                          <Field
                                            name={`ListOfMaterials[${indx}].TCNo`}
                                            placeholder={"TC No"}
                                            options={tcNoOptions}
                                            component={CustomSelect}
                                            maxLength={100}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                          />
                                        ) : item.TCNoAllocated == false ||
                                          !item.InwardMaterialIDEncrypted ? (
                                          ""
                                        ) : (
                                          <Field
                                            name={`ListOfMaterials[${indx}].TCNo`}
                                            placeholder={"TC No"}
                                            component={CustomInput}
                                            disabled={true}
                                            noMarginBottom={true}
                                          />
                                        )}
                                      </td>

                                      {/* <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].DepartmentIDEncrypted`}
                                        placeholder={"Department"}
                                        options={departmentOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfMaterials[${indx}].DepartmentIDEncrypted`,
                                            e?.value ?? ""
                                          );
                                          getProductGroupDDL(
                                            e?.value ?? "",
                                            indx
                                          );
                                          formik.setFieldValue(
                                            `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                            ""
                                          );
                                          getMaterialTypeDDL(
                                            e?.value ?? "",
                                            "",
                                            indx
                                          );
                                          getTestDDL(
                                            e?.value ?? "",
                                            "",
                                            "",
                                            indx
                                          );
                                        }}
                                      />
                                    </td> */}
                                      {/* <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].ProductGroupIDEncrypted`}
                                        placeholder={"Material Group"}
                                        options={productGroupOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                            e?.value ?? ""
                                          );
                                          // getMaterialTypeDDL(
                                          //   item.DepartmentIDEncrypted,
                                          //   e?.value ?? "",
                                          //   indx
                                          // );
                                          getMaterialTypeDDL(
                                            e?.value ?? "",
                                            indx
                                          );
                                          formik.setFieldValue(
                                            `ListOfMaterials[${indx}].MaterialTypeIDEncrypted`,
                                            ""
                                          );
                                          getDepartmentDDL(
                                            e?.value ?? "",
                                            indx
                                          );
                                          // getTestDDL(
                                          //   item.DepartmentIDEncrypted,
                                          //   e?.value ?? "",
                                          //   "",
                                          //   indx
                                          // );
                                          getTestDDL(
                                            "",
                                            e?.value ?? "",
                                            "",
                                            indx,
                                            -1
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <Field
                                        name={`ListOfMaterials[${indx}].MaterialTypeIDEncrypted`}
                                        placeholder={"Material Type"}
                                        options={item.materialTypeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfMaterials[${indx}].MaterialTypeIDEncrypted`,
                                            e?.value ?? ""
                                          );
                                          // getTestDDL(
                                          //   item.DepartmentIDEncrypted,
                                          //   item.ProductGroupIDEncrypted,
                                          //   e?.value ?? "",
                                          //   indx
                                          // );
                                          getTestDDL(
                                            "",
                                            item.ProductGroupIDEncrypted,
                                            e?.value ?? "",
                                            indx,
                                            -1
                                          );
                                        }}
                                      />
                                    </td> */}

                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {/* <Field
                                          name={`ListOfMaterials[${indx}].SampleDetail`}
                                          placeholder={"Sample Detail"}
                                          component={CustomInput}
                                          maxLength={2000}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                        /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].SampleDetail`}
                                          placeholder={"Sample Detail"}
                                          defaultValue={item.SampleDetail}
                                          maxLength={2000}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].SampleDetail`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "110px" }}
                                      >
                                        {/* <Field
                                          name={`ListOfMaterials[${indx}].Condition`}
                                          placeholder={"Condition"}
                                          component={CustomInput}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                        /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].Condition`}
                                          placeholder={"Condition"}
                                          defaultValue={item.Condition}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].Condition`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{ minWidth: "100px" }}
                                      >
                                        {/* <Field
                                          name={`ListOfMaterials[${indx}].Size`}
                                          placeholder={"Size"}
                                          component={CustomInput}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                        /> */}
                                        <CustomInputUncontrolled
                                          name={`ListOfMaterials[${indx}].Size`}
                                          placeholder={"Size"}
                                          defaultValue={item.Size}
                                          maxLength={500}
                                          noMarginBottom={true}
                                          disabled={
                                            item?.IsHold || ViewPrimaryIdParam
                                          }
                                          onValueCommit={(val) => {
                                            formik.setFieldValue(
                                              `ListOfMaterials[${indx}].Size`,
                                              val,
                                            );
                                          }}
                                        />
                                      </td>
                                      {AuthUser?.Permissions?.Machining == 1 ? (
                                        <td
                                          className="p-1"
                                          style={{ minWidth: "100px" }}
                                        >
                                          <div className="form-check form-switch ms-4">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              id="flexSwitchCheckMachining"
                                              title={
                                                item?.IsMachining == true
                                                  ? "Yes"
                                                  : "No"
                                              }
                                              checked={item?.IsMachining}
                                              onChange={(e) => {
                                                handleChangeIsMachining(
                                                  indx,
                                                  e,
                                                  item,
                                                );
                                              }}
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              disabled={
                                                item?.IsHold ||
                                                ViewPrimaryIdParam
                                              }
                                            ></input>
                                            &nbsp;
                                            {item?.IsMachining == true ? (
                                              <Link
                                                to="#"
                                                className="text-primary"
                                                title="View Machining Details"
                                                onClick={() => {
                                                  if (item?.IsHold == false) {
                                                    getMaterialProcessDetails(
                                                      indx,
                                                      item?.IsMachining,
                                                      item?.InwardMaterialIDEncrypted,
                                                    );
                                                  }
                                                }}
                                                disabled={item?.IsHold}
                                              >
                                                View
                                              </Link>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                      <td
                                        className="p-1"
                                        style={{ textAlign: "center" }}
                                      >
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-primary-light"
                                          className="icon-box icon-box-md"
                                          onClick={() => {
                                            handleOnClickMaterialInfoImages(
                                              indx,
                                              item,
                                            );
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          {/* Upload / View */}
                                          <i className="fa fa-cloud-upload"></i>
                                        </Link>
                                      </td>
                                    </tr>
                                    <tr
                                      key={`iRow_${indx}`}
                                      style={{
                                        display:
                                          item.IsDeleted == true ? "none" : "",
                                      }}
                                    >
                                      <td
                                        className="p-1 pt-3"
                                        style={{
                                          verticalAlign: "top",
                                        }}
                                      >
                                        {!ViewPrimaryIdParam ? (
                                          <>
                                            {ListOfMaterials?.filter(
                                              (x) => x.IsDeleted == false,
                                            )?.length > 1 &&
                                              item?.ListOfMaterialTestDetails?.filter(
                                                (x) => x.IsDeleted == false,
                                              )?.length > 0 && (
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light"
                                                  className="icon-box icon-box-md"
                                                  title="Repeat Test Details"
                                                  onClick={() => {
                                                    handleOnClickRepeatTestDetails(
                                                      indx,
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-repeat" />
                                                </Link>
                                              )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td
                                        colSpan={9}
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          maxWidth: "500px",
                                        }}
                                      >
                                        <Accordion
                                          className="accordion accordion-solid-bg"
                                          defaultActiveKey="0"
                                        >
                                          <Accordion.Item
                                            className="accordion-item m-0"
                                            key={indx}
                                            eventKey={"0"}
                                          >
                                            <Accordion.Header className="accordion-header rounded-lg">
                                              Test Details
                                            </Accordion.Header>
                                            <Accordion.Collapse eventKey={"0"}>
                                              <div className="accordion-body p-0">
                                                <div className="table-responsive active-projects style-1 shorting">
                                                  <div
                                                    id="MaterialTestInfo-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="MaterialTestInfo-tbl"
                                                      className="table table-bordered no-footer mb-0"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th
                                                            width="2%"
                                                            className="ps-2 newPara"
                                                          >
                                                            {!ViewPrimaryIdParam ? (
                                                              <>
                                                                {item?.IsHold ==
                                                                  false && (
                                                                  <Link
                                                                    to="#"
                                                                    className="icon-box icon-box-md bg-primary-light"
                                                                    title="Add New"
                                                                    onClick={() => {
                                                                      AddNewMaterialTestInformation(
                                                                        indx,
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i className="fa fa-plus"></i>
                                                                  </Link>
                                                                )}
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </th>
                                                          <th
                                                            width="14%"
                                                            className="newPara"
                                                          >
                                                            Department
                                                          </th>
                                                          <th
                                                            width="18%"
                                                            className="newPara"
                                                          >
                                                            Test
                                                          </th>
                                                          <th className="newPara"></th>
                                                          <th
                                                            width="12%"
                                                            className="newPara"
                                                          >
                                                            Material Group
                                                          </th>
                                                          <th
                                                            width="12%"
                                                            className="newPara"
                                                          >
                                                            Material Type
                                                          </th>
                                                          {/* <th
                                                          width="13%"
                                                          className="newPara"
                                                        >
                                                          Test Method
                                                        </th> */}
                                                          <th
                                                            width="14%"
                                                            className="newPara"
                                                          >
                                                            Ref. Standard
                                                          </th>
                                                          <th
                                                            width="9%"
                                                            className="newPara"
                                                          >
                                                            Group
                                                          </th>
                                                          <th className="newPara"></th>
                                                          <th
                                                            width="5%"
                                                            className="newPara"
                                                          >
                                                            Test Count
                                                          </th>
                                                          {AuthUser?.Permissions
                                                            ?.Account === 1 ? (
                                                            <th
                                                              width="5%"
                                                              className="newPara"
                                                            >
                                                              Billing Qty
                                                            </th>
                                                          ) : (
                                                            ""
                                                          )}
                                                          {/* 
                                                        <th width="10%" className="newPara">
                                                          Unit
                                                        </th>
                                                        <th width="10%" className="newPara">
                                                          Rate
                                                        </th> */}
                                                          {/* <th
                                                          width="10%"
                                                          className="newPara"
                                                        >
                                                          Machining
                                                        </th> */}
                                                          <th
                                                            width="9%"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                            className="newPara"
                                                          >
                                                            Note
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {item?.ListOfMaterialTestDetails?.filter(
                                                          (x) =>
                                                            x.IsDeleted ==
                                                            false,
                                                        )?.length > 0 ? (
                                                          item?.ListOfMaterialTestDetails?.map(
                                                            (
                                                              itemTest,
                                                              indxTest,
                                                            ) => (
                                                              <tr
                                                                key={`test_${indxTest}`}
                                                                style={{
                                                                  display:
                                                                    itemTest?.IsDeleted ==
                                                                    true
                                                                      ? "none"
                                                                      : "",
                                                                }}
                                                              >
                                                                <td className="p-1">
                                                                  {itemTest?.IsCancel ==
                                                                  false ? (
                                                                    item?.IsHold ==
                                                                      false &&
                                                                    (!ViewPrimaryIdParam ? (
                                                                      <Link
                                                                        to="#"
                                                                        // className="icon-box icon-box-md bg-danger-light"
                                                                        className="icon-box icon-box-md"
                                                                        title="Delete"
                                                                        onClick={() => {
                                                                          //deleteMaterialTestInformation(indx,indxTest);
                                                                          delete_RecordWithoutApi(
                                                                            deleteMaterialTestInformation,
                                                                            indx,
                                                                            indxTest,
                                                                          );
                                                                        }}
                                                                      >
                                                                        {
                                                                          SVGICON.DeleteDanger
                                                                        }
                                                                      </Link>
                                                                    ) : (
                                                                      ""
                                                                    ))
                                                                  ) : (
                                                                    <i
                                                                      className="fa fa-ban ps-2 text-danger"
                                                                      title="Cancelled"
                                                                    ></i>
                                                                  )}
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].DepartmentIDEncrypted`}
                                                                    placeholder={
                                                                      "Department"
                                                                    }
                                                                    options={
                                                                      departmentOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      itemTest?.IsMixDesignIncludedTest
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      if (
                                                                        e &&
                                                                        e?.value &&
                                                                        e?.IsNABLScopeExpired ==
                                                                          true
                                                                      ) {
                                                                        customConfirmDialog(
                                                                          `${e?.label} Scope is Expired`,
                                                                          `Do you want to continue?`,
                                                                          () => {
                                                                            handleChangeDepartment(
                                                                              indx,
                                                                              indxTest,
                                                                              e,
                                                                            );
                                                                          },
                                                                          true,
                                                                        );
                                                                      } else {
                                                                        handleChangeDepartment(
                                                                          indx,
                                                                          indxTest,
                                                                          e,
                                                                        );
                                                                      }
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                    borderRight:
                                                                      "1px solid transparent",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMasterIDEncrypted`}
                                                                    placeholder={
                                                                      "Test"
                                                                    }
                                                                    // options={
                                                                    //   item.testOptions
                                                                    // }
                                                                    options={
                                                                      itemTest?.testOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam ||
                                                                      itemTest?.IsMixDesignIncludedTest
                                                                    }
                                                                    menuPosition="fixed"
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeTestMaster(
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                        itemTest,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td className="p-1">
                                                                  <>
                                                                    {itemTest?.TestMasterIDEncrypted && (
                                                                      <>
                                                                        {AuthUser
                                                                          ?.Permissions
                                                                          ?.Account ==
                                                                        1 ? (
                                                                          <Link
                                                                            to="#"
                                                                            className="icon-box icon-box-md bg-primary-light"
                                                                            title="Define More Rates Selection"
                                                                            disabled={
                                                                              itemTest?.IsCancel ||
                                                                              item?.IsHold
                                                                            }
                                                                            onClick={() => {
                                                                              handleOnClickDefineMoreRatesSelection(
                                                                                indx,
                                                                                indxTest,
                                                                                item,
                                                                                itemTest,
                                                                                itemTest?.TestMasterIDEncrypted,
                                                                                itemTest?.InwardMaterialTestDetailIDEncrypted,
                                                                              );
                                                                            }}
                                                                          >
                                                                            {
                                                                              SVGICON.Rates
                                                                            }
                                                                          </Link>
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </>
                                                                    )}
                                                                    {itemTest?.TestMasterIDEncrypted &&
                                                                      itemTest?.IsMixDesign ==
                                                                        true && (
                                                                        <Link
                                                                          to="#"
                                                                          className="icon-box icon-box-md bg-primary-light ms-1"
                                                                          title="Mix Design Details"
                                                                          disabled={
                                                                            itemTest?.IsCancel ||
                                                                            item?.IsHold
                                                                          }
                                                                          onClick={() => {
                                                                            handleOnClickMixDesignDetail(
                                                                              indx,
                                                                              indxTest,
                                                                              item,
                                                                              itemTest,
                                                                            );
                                                                          }}
                                                                        >
                                                                          {
                                                                            SVGICON.Setting2
                                                                          }
                                                                        </Link>
                                                                      )}
                                                                  </>
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`}
                                                                    placeholder={
                                                                      "Material Group"
                                                                    }
                                                                    options={
                                                                      itemTest?.productGroupOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    menuPosition="fixed"
                                                                    // onChange={(
                                                                    //   e
                                                                    // ) => {
                                                                    //   formik.setFieldValue(
                                                                    //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`,
                                                                    //     e?.value ??
                                                                    //       ""
                                                                    //   );
                                                                    //   // formik.setFieldValue(
                                                                    //   //   `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                    //   //   ""
                                                                    //   // );
                                                                    //   // getTestDDL(
                                                                    //   //   itemTest?.DepartmentIDEncrypted,
                                                                    //   //   e?.value ??
                                                                    //   //     "",
                                                                    //   //   "",
                                                                    //   //   indx,
                                                                    //   //   indxTest
                                                                    //   // );
                                                                    // }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`}
                                                                    placeholder={
                                                                      "Material Type"
                                                                    }
                                                                    options={
                                                                      itemTest?.materialTypeOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    menuPosition="fixed"
                                                                    // onChange={(
                                                                    //   e
                                                                    // ) => {
                                                                    //   formik.setFieldValue(
                                                                    //     `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                                    //     e?.value ??
                                                                    //       ""
                                                                    //   );
                                                                    //   // getTestDDL(
                                                                    //   //   itemTest?.DepartmentIDEncrypted,
                                                                    //   //   itemTest?.ProductGroupIDEncrypted,
                                                                    //   //   e?.value ??
                                                                    //   //     "",
                                                                    //   //   indx,
                                                                    //   //   indxTest
                                                                    //   // );
                                                                    // }}
                                                                  />
                                                                </td>

                                                                {/* <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "150px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`}
                                                                  placeholder={
                                                                    "Test Method"
                                                                  }
                                                                  options={
                                                                    itemTest?.testMethodOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  isDisabled={
                                                                    itemTest?.IsCancel
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      e?.IsExpiredTestMethod ==
                                                                      true
                                                                    ) {
                                                                      warningMessage(
                                                                        "Test Method is Expired..!"
                                                                      );
                                                                    } else {
                                                                      formik.setFieldValue(
                                                                        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`,
                                                                        e?.value ??
                                                                          ""
                                                                      );
                                                                    }
                                                                  }}
                                                                />
                                                              </td> */}
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`}
                                                                    placeholder={
                                                                      "Ref. Standard"
                                                                    }
                                                                    options={
                                                                      itemTest?.referenceStandardOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeReferenceStandard(
                                                                        itemTest?.TestMasterIDEncrypted,
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "100px",
                                                                    borderRight:
                                                                      "1px solid transparent",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].RefStandardSubGroup`}
                                                                    placeholder={
                                                                      "Group"
                                                                    }
                                                                    options={
                                                                      itemTest?.refStandardSubGroupOptions
                                                                    }
                                                                    component={
                                                                      CustomSelect
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    menuPosition="fixed"
                                                                    isDisabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeRefStandardSubGroup(
                                                                        itemTest?.ReferenceStandardIDEncrypted,
                                                                        itemTest?.TestMasterIDEncrypted,
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td className="p-1">
                                                                  {itemTest?.TestMasterIDEncrypted && (
                                                                    <Link
                                                                      to="#"
                                                                      className="icon-box icon-box-md bg-primary-light"
                                                                      title="Parameters Selection"
                                                                      disabled={
                                                                        itemTest?.IsCancel ||
                                                                        item?.IsHold
                                                                      }
                                                                      onClick={() => {
                                                                        handleOnClickParameterSelection(
                                                                          indx,
                                                                          indxTest,
                                                                          item,
                                                                          itemTest,
                                                                        );
                                                                      }}
                                                                    >
                                                                      <i className="fa fa-tags"></i>
                                                                    </Link>
                                                                  )}
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    minWidth:
                                                                      "105px",
                                                                  }}
                                                                >
                                                                  <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestCount`}
                                                                    placeholder={
                                                                      "Test Count"
                                                                    }
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    type="number"
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    numberTypeWithoutDot={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      handleChangeTestCount(
                                                                        indx,
                                                                        indxTest,
                                                                        e,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                {AuthUser
                                                                  ?.Permissions
                                                                  ?.Account ===
                                                                1 ? (
                                                                  <td
                                                                    className="p-1"
                                                                    style={{
                                                                      minWidth:
                                                                        "105px",
                                                                    }}
                                                                  >
                                                                    <Field
                                                                      name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].BillingQty`}
                                                                      placeholder={
                                                                        "Billing Qty"
                                                                      }
                                                                      component={
                                                                        CustomInput
                                                                      }
                                                                      type="number"
                                                                      noMarginBottom={
                                                                        true
                                                                      }
                                                                      numberTypeWithoutDot={
                                                                        true
                                                                      }
                                                                      disabled={
                                                                        itemTest?.IsCancel ||
                                                                        item?.IsHold ||
                                                                        ViewPrimaryIdParam
                                                                      }
                                                                    />
                                                                  </td>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                {/*
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "130px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].UnitID`}
                                                                  placeholder={
                                                                    "Unit"
                                                                  }
                                                                  options={
                                                                    unitOptions
                                                                  }
                                                                  component={
                                                                    CustomSelect
                                                                  }
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  menuPosition="fixed"
                                                                  isDisabled={
                                                                    itemTest?.IsCancel
                                                                  }
                                                                />
                                                              </td>
                                                              <td
                                                                className="p-1"
                                                                style={{
                                                                  minWidth:
                                                                    "110px",
                                                                }}
                                                              >
                                                                <Field
                                                                  name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].Rate`}
                                                                  placeholder={
                                                                    "Rate"
                                                                  }
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  type="number"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  disabled={
                                                                    itemTest?.IsCancel
                                                                  }
                                                                />
                                                              </td> */}
                                                                {/* <td
                                                                className="p-1"
                                                                style={{
                                                                  display:
                                                                    "none",
                                                                }}
                                                              >
                                                                <div className="form-check form-switch ms-4">
                                                                  <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    id="flexSwitchCheckMachiningTestWise"
                                                                    title={
                                                                      itemTest.IsMachining ==
                                                                      true
                                                                        ? "Yes"
                                                                        : "No"
                                                                    }
                                                                    checked={
                                                                      itemTest.IsMachining
                                                                    }
                                                                    onChange={() => {
                                                                      formik.setFieldValue(
                                                                        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].IsMachining`,
                                                                        !itemTest.IsMachining
                                                                      );
                                                                    }}
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                  ></input>
                                                                </div>
                                                              </td> */}
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    minWidth:
                                                                      "150px",
                                                                  }}
                                                                >
                                                                  {/* <Field
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`}
                                                                    placeholder={
                                                                      "Note"
                                                                    }
                                                                    component={
                                                                      CustomInput
                                                                    }
                                                                    maxLength={
                                                                      100
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                  /> */}
                                                                  <CustomInputUncontrolled
                                                                    name={`ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`}
                                                                    placeholder={
                                                                      "Note"
                                                                    }
                                                                    defaultValue={
                                                                      item.TestNote
                                                                    }
                                                                    maxLength={
                                                                      100
                                                                    }
                                                                    noMarginBottom={
                                                                      true
                                                                    }
                                                                    disabled={
                                                                      itemTest?.IsCancel ||
                                                                      item?.IsHold ||
                                                                      ViewPrimaryIdParam
                                                                    }
                                                                    onValueCommit={(
                                                                      val,
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListOfMaterials[${indx}].ListOfMaterialTestDetails[${indxTest}].TestNote`,
                                                                        val,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan={10}
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <div>
                                                                {
                                                                  "No Record Found..."
                                                                }
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </Accordion.Collapse>
                                          </Accordion.Item>
                                        </Accordion>
                                      </td>
                                    </tr>
                                    <tr className="border-0 p-0">
                                      <td colSpan={9} className="p-0">
                                        <hr className="m-0 customHR"></hr>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={9} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <ErrorMessage
                        name={"ListOfMaterials"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      <ErrorMessage
                        name={`TestError`}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      {filteredMaterials?.length > 20 && (
                        <div className="d-flex justify-content-end align-items-center gap-2 mt-2 mb-2">
                          {/* PAGE SIZE DROPDOWN */}
                          <div className="d-flex align-items-center gap-2">
                            {/* <span>Show</span>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "70px", isDisabled: true }}
                            value={pageSize}
                            // onChange={(e) =>
                            //   setPageSize(Number(e.target.value))
                            // }
                          >
                            {PAGE_SIZE_OPTIONS.map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                          <span>Records</span> */}
                            Showing{" "}
                            {filteredMaterials.length > 0
                              ? (page + 1 - 1) * pageSize + 1
                              : 0}{" "}
                            to{" "}
                            {filteredMaterials.length > (page + 1) * pageSize
                              ? (page + 1) * pageSize
                              : filteredMaterials.length}{" "}
                            of {filteredMaterials.length} records
                          </div>

                          {/* PAGINATION */}
                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={page === 0}
                              onClick={() => setPage((p) => p - 1)}
                            >
                              Prev
                            </button>

                            <span>
                              Page {page + 1} of {totalPages}
                            </span>

                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={page >= totalPages - 1}
                              onClick={() => setPage((p) => p + 1)}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                {ViewPrimaryIdParam ? (
                  <>
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <label>Mode</label>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="Mode-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="Mode-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="14%">Mode Type</th>
                                  <th width="14%">Mode By </th>
                                  <th width="18%">Customer</th>
                                  <th width="18%">Project</th>
                                  <th width="20%">Address</th>
                                  <th width="16%" style={{ textAlign: "left" }}>
                                    Contact Person
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfModeDetails?.map((item, idx) => (
                                  <tr key={idx}>
                                    <td
                                      className="p-1 ps-3"
                                      style={{ minWidth: "150px" }}
                                    >
                                      <label>
                                        {item.ModeDetailID == 1
                                          ? "Sample Submitted By"
                                          : item.ModeDetailID == 2
                                            ? "Reporting"
                                            : item.ModeDetailID == 3
                                              ? "Billing"
                                              : item.ModeDetailID == 4
                                                ? "Dispatch"
                                                : ""}
                                      </label>
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      {item?.ModeTypeName ? (
                                        <Field
                                          name={`ListOfModeDetails[${idx}].ModeTypeName`}
                                          placeholder={"Mode Type"}
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                          disabled={ViewPrimaryIdParam}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "160px" }}
                                    >
                                      <Field
                                        name={`ListOfModeDetails[${idx}].CustomerName`}
                                        placeholder={"Customer Name"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "160px" }}
                                    >
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ProjectName`}
                                        placeholder={"Project Name"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "180px" }}
                                    >
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ProjectAddress`}
                                        placeholder={"Address"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "150px",
                                      }}
                                    >
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ContactPerson`}
                                        placeholder={"Contact Person"}
                                        component={CustomInput}
                                        maxLength={500}
                                        noMarginBottom={true}
                                        disabled={ViewPrimaryIdParam}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Expected Delivery Date"
                          name="ExpectedDateOfDelivery"
                          placeholder={"Expected Delivery Date"}
                          component={CustomInput}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Material Taken By Employee"
                          name="MaterialTakenByUserName"
                          placeholder={"Material Taken By"}
                          component={CustomInput}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Sample Received Via"
                          name="MaterialReceiveVia"
                          placeholder={"Sample Received Via"}
                          component={CustomInput}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Reference By"
                          name="ReferenceByName"
                          placeholder={"Reference By"}
                          component={CustomInput}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Delivery Remarks"
                          name="EDDRemarks"
                          placeholder={"Delivery Remarks"}
                          component={CustomTextArea}
                          rows={2}
                          maxLength={200}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Received Remarks"
                          name="ReceiveRemarks"
                          placeholder={"Received Remarks"}
                          component={CustomTextArea}
                          rows={2}
                          maxLength={100}
                          disabled={ViewPrimaryIdParam}
                        />
                      </Col>
                    </Row>
                    {ListOfReviews?.length > 0 && (
                      <>
                        <hr className="mt-1 mb-1"></hr>
                        <Row>
                          <label>Customer Review</label>
                          <Col lg={12}>
                            <div className="table-responsive active-projects style-1 shorting mb-2">
                              <div
                                id="Review-tbl_wrapper"
                                className="dataTables_wrapper table-responsive no-footer"
                              >
                                <table
                                  id="Review-tbl"
                                  className="table table-bordered no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="4%"></th>
                                      <th width="82%">Points Reviewed</th>
                                      <th
                                        width="14%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Status of review
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ListOfReviews?.length > 0 ? (
                                      ListOfReviews?.map((item, indx) => (
                                        <tr key={indx}>
                                          <td
                                            className="p-1 text-center"
                                            style={{ minWidth: "40px" }}
                                          >
                                            {indx + 1}
                                          </td>

                                          <td
                                            className="p-1"
                                            style={{ minWidth: "180px" }}
                                          >
                                            {item.Review}
                                          </td>

                                          <td
                                            className="p-1"
                                            style={{
                                              textAlign: "left",
                                              minWidth: "150px",
                                            }}
                                          >
                                            <Field
                                              name={`ListOfReviews[${indx}].StatusOfReview`}
                                              placeholder={"Select"}
                                              options={yesNoOptions}
                                              component={CustomSelect}
                                              noMarginBottom={true}
                                              menuPosition="fixed"
                                              isClearable={false}
                                              isDisabled={ViewPrimaryIdParam}
                                            />
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={3}
                                          style={{ textAlign: "left" }}
                                        >
                                          <div>{"No Record Found..."}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}

                <div className="stickyBottomButtons">
                  <hr className="mt-0 mb-2"></hr>
                  {!ViewPrimaryIdParam ? (
                    <>
                      {InwardCurrentStatus == 2 || InwardCurrentStatus == 3 ? (
                        <>
                          <button
                            type="submit"
                            // className="btn btn-primary"
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => {
                              formik.setFieldValue("btnSubmitType", 1);
                            }}
                            disabled={formik.isSubmitting}
                          >
                            <i className="fa fa-bookmark"></i>{" "}
                            {formik.isSubmitting ? "Drafting..." : "Draft"}
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 2);
                        }}
                        disabled={formik.isSubmitting}
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {formik.isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </>
                  ) : (
                    ""
                  )}

                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>

        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  {!ViewPrimaryIdParam ? (
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="LetterRefUpload2"
                          //accept="image/png, image/gif, image/jpeg"
                          onChange={uploadLetterRefDoc}
                          //key={fileKeyMaterialPhoto || ""}
                        />
                        <label htmlFor="LetterRefUpload2" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalLetterRefDocImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                  </div> */}
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDoc-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDoc-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false,
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam ? (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteLetterRefDoc(indx);
                                        delete_RecordWithoutApi(
                                          deleteLetterRefDoc,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={captureLetterRefDocPhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="fade"
          show={showAddTPIDetailModal}
          onHide={setShowAddTPIDetailModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTPIDetail}>
              <Form onSubmit={formikTPIDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="TPI"
                        name="TPIIDEncrypted"
                        placeholder={"Select TPI"}
                        options={tpiCustomerOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIIDEncrypted",
                            e?.value ?? "",
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIName",
                            e?.label ?? "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Contact Person"
                        name="TPIContactPersonIDEncrypted"
                        placeholder={"Select Contact Person"}
                        options={tpiContactPersonOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonIDEncrypted",
                            e?.value ?? "",
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonName",
                            e?.label ?? "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Expected Date"
                        name="TPIExpectedDate"
                        placeholder={"Select Expected Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate ? InwardDate : new Date(),
                          static: true, //to solve month dropdown not visible inside modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showTPIDetailModal}
          onHide={setShowTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {/* <Col lg={12}>
                  <div className="mb-1" style={{ float: "right" }}>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        addNewTPI();
                      }}
                    >
                      + Add
                    </button>
                  </div>
                </Col> */}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            {!ViewPrimaryIdParam ? (
                              <th width="4%">
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md bg-primary-light me-1"
                                  title="Add TPI Detail"
                                  onClick={() => {
                                    addNewTPI();
                                  }}
                                >
                                  <i className="fa fa-plus"></i>
                                </Link>
                              </th>
                            ) : (
                              ""
                            )}
                            <th width="40%">TPI</th>
                            <th width="36%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTPIDetails?.filter((x) => x.IsDeleted == false)
                            ?.length > 0 ? (
                            ListOfTPIDetails?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                {!ViewPrimaryIdParam ? (
                                  <td>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editTPI(indx);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteTPI(indx);
                                        delete_RecordWithoutApi(
                                          deleteTPI,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                ) : (
                                  ""
                                )}
                                <td>{item.TPIName}</td>
                                <td>{item.TPIContactPersonName}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.displayTPIExpectedDate}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showMaterialInfoImagesModal}
          onHide={setShowMaterialInfoImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Images - Material Information</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {!ViewPrimaryIdParam ? (
                  <Col lg={12}>
                    <div className="mb-2">
                      <label></label>
                      <div className="avatar-file">
                        <input
                          type="file"
                          id="imageUploadMaterial"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadMaterialPhoto}
                          key={fileKeyMaterialPhoto || ""}
                        />
                        <label htmlFor="imageUploadMaterial" name=""></label>
                      </div>
                      <div
                        id="webCam"
                        className="avatar-camera"
                        onClick={() => {
                          setOpenWebCamModalMaterialImage(true);
                        }}
                        style={{ marginLeft: "50px" }}
                      >
                        <input type="hidden" />
                        <label htmlFor="webCam" name=""></label>
                      </div>
                    </div>
                  </Col>
                ) : (
                  ""
                )}
                {materialPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={materialPhoto ? materialPhoto : img200}
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addMaterialImage();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setMaterialPhoto(null);
                            setMaterialPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Image
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMaterials[
                            selectedMaterialInfoRow
                          ]?.ListOfMaterialPhotos?.filter(
                            (x) => x.IsDeleted == false,
                          )?.length > 0 ? (
                            ListOfMaterials[
                              selectedMaterialInfoRow
                            ]?.ListOfMaterialPhotos?.map((item, indx) => (
                              <tr
                                key={`img_${indx}`}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MaterialPhotoFilePath
                                          ? item.MaterialPhotoFilePath
                                          : item.viewFile,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  {!ViewPrimaryIdParam ? (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteMaterialImage(indx);
                                        delete_RecordWithoutApi(
                                          deleteMaterialImage,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <img
                                    src={
                                      item.MaterialPhotoFilePath
                                        ? item.MaterialPhotoFilePath
                                        : item.viewFile
                                    }
                                    alt={"Material Image"}
                                    style={{
                                      maxHeight: "50px",
                                      maxWidth: "50px",
                                    }}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {(openCropperModalMaterialPhoto == true ||
                openWebCamModalMaterialImage == true) && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={openCropperModalMaterialPhoto}
          onHide={setOpenCropperModalMaterialPhoto}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenCropperModalMaterialPhoto(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <Cropper
                  //style={{ height: 400, width: 400 }}
                  // zoomTo={0.5}
                  zoomTo={zoomMaterialPhoto}
                  initialAspectRatio={1 / 1}
                  // aspectRatio={1 / 1}
                  src={imageMaterialPhoto}
                  // viewMode={1}
                  // minCropBoxHeight={500}
                  // minCropBoxWidth={500}
                  // maxCropBoxHeight={500}
                  // maxCropBoxWidth={500}
                  background={false}
                  responsive={true}
                  // autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropperMaterialPhoto(instance);
                  }}
                  //guides={false}
                  checkCrossOrigin={false}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(zoomMaterialPhoto + 0.5);
              }}
              title="zoom-in"
            >
              <i className="fa fa-search-plus"></i>
            </Button>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(
                  zoomMaterialPhoto > 0.5
                    ? zoomMaterialPhoto - 0.5
                    : zoomMaterialPhoto,
                );
              }}
              title="zoom-out"
            >
              <i className="fa fa-search-minus"></i>
            </Button>
            <Button
              // className="btn btn-primary"
              variant="primary btn-sm"
              onClick={() => {
                getCropDataMaterialPhoto();
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9),
                );
              }}
            >
              <i className="fa fa-crop"></i> Crop Image
            </Button>
            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9),
                );
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="fade"
          show={openWebCamModalMaterialImage}
          onHide={setOpenWebCamModalMaterialImage}
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalMaterialImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={capturePhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalMaterialImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="fade"
          show={showMaterialInfoRepeatRowQtyModal}
          onHide={setShowMaterialInfoRepeatRowQtyModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialInfoRepeatRow}>
              <Form onSubmit={formikMaterialInfoRepeatRow.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat Row - Material Information</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialInfoRepeatRowQtyModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        type="number"
                        label="No of Repeat Row"
                        name="NoOfRepeatMaterialInfoRow"
                        placeholder={"Enter No of Repeat Row"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                        onChange={(e) => {
                          let nRow = e?.target?.value ?? 0;
                          if (nRow >= 0 && nRow < 100) {
                            formikMaterialInfoRepeatRow.setFieldValue(
                              "NoOfRepeatMaterialInfoRow",
                              e?.target?.value ?? "",
                            );
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMaterialInfoRepeatRowQtyModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showWorkDetailModal}
          onHide={setShowWorkDetailModal}
          size="lg"
        >
          <FormikProvider value={formikWorkDetail}>
            <Form onSubmit={formikWorkDetail.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Work Detail</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowWorkDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="workDetail-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="workDetail-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Work Detail
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectWorkDetailList?.length > 0 ? (
                              projectWorkDetailList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkWorkDetail${indx}`}
                                      name={`chkWorkDetail${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikWorkDetail.setFieldValue(
                                          "projectWorkDetailList",
                                          projectWorkDetailList?.map(
                                            (x, idx) => {
                                              if (idx == indx) {
                                                return {
                                                  ...x,
                                                  IsSelected: true,
                                                };
                                              } else {
                                                return {
                                                  ...x,
                                                  IsSelected: false,
                                                };
                                              }
                                            },
                                          ),
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.WorkDetail}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowWorkDetailModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>

        <Modal
          className="fade"
          show={showMaterialProcessModal}
          onHide={setShowMaterialProcessModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialProcessDetail}>
              <Form onSubmit={formikMaterialProcessDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Machining Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialProcessModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="MaterialProcess-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="MaterialProcess-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                {!ViewPrimaryIdParam ? (
                                  <th width="4%"></th>
                                ) : (
                                  ""
                                )}
                                <th width="28%">Process Name</th>
                                <th width="24%">Process Note</th>
                                <th width="12%">Qty</th>
                                <th width="12%">Length</th>
                                <th width="20%" style={{ textAlign: "left" }}>
                                  Thickness
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfProcessThicknessDetails?.length > 0 ? (
                                ListOfProcessThicknessDetails?.map(
                                  (itemTest, indxTest) => (
                                    <tr
                                      key={indxTest}
                                      style={{
                                        display:
                                          itemTest.IsDeleted == true
                                            ? "none"
                                            : "",
                                      }}
                                    >
                                      {!ViewPrimaryIdParam ? (
                                        <td className="p-1">
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-primary-light"
                                            title="New Process"
                                            onClick={(e) => {
                                              addNewProcess(indxTest);
                                              e.preventDefault();
                                            }}
                                          >
                                            <i className="fa fa-plus"></i>
                                          </Link>
                                          {ListOfProcessThicknessDetails?.filter(
                                            (x) => x.IsDeleted == false,
                                          )?.length > 1 ? (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-danger-light ms-1"
                                              title="Remove Process"
                                              onClick={(e) => {
                                                removeProcess(indxTest);
                                                e.preventDefault();
                                              }}
                                            >
                                              <i className="fa fa-minus"></i>
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`}
                                          placeholder={"Process Name"}
                                          options={processNameOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          onChange={(e) => {
                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].MachiningConfigurationIDEncrypted`,
                                              e?.value ?? "",
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].VendorRate`,
                                              e?.RateMatrix == false
                                                ? (e?.VendorRate ?? "")
                                                : "",
                                            );

                                            formikMaterialProcessDetail.setFieldValue(
                                              `ListOfProcessThicknessDetails[${indxTest}].InvoiceRate`,
                                              e?.RateMatrix == false
                                                ? (e?.InvoiceRate ?? "")
                                                : "",
                                            );

                                            checkValidationProcess(
                                              e?.value,
                                              indxTest,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].MachiningNote`}
                                          placeholder={"Process Note"}
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Qty`}
                                          placeholder={"Qty"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                          numberTypeWithoutDot={true}
                                          onChange={(e) => {
                                            if (e?.target?.value < 1000) {
                                              formikMaterialProcessDetail.setFieldValue(
                                                `ListOfProcessThicknessDetails[${indxTest}].Qty`,
                                                e?.target?.value ?? "",
                                              );
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "105px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Length`}
                                          placeholder={"Length"}
                                          component={CustomInput}
                                          type="number"
                                          noMarginBottom={true}
                                        />
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfProcessThicknessDetails[${indxTest}].Thickness`}
                                          placeholder={"Thickness"}
                                          type="number"
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={10}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {showAddTPIDetailModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      type="submit"
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // variant="secondary light"
                    variant="danger btn-sm"
                    onClick={() => setShowMaterialProcessModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showTestDetailsRepeatModal}
          onHide={setShowTestDetailsRepeatModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestDetailsRepeat}>
              <Form onSubmit={formikTestDetailsRepeat.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat - Test Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestDetailsRepeatModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <ul className="unorder-list ps-4 mb-2">
                        <li>
                          Selected Material Information(TC) Test Details should
                          be repeat in all the Material Information(TC).
                          {/* which is
                          having Material Group is{" "}
                          <b>"{repeatTestDetailsProductGroupName}"</b> and
                          Material Type is{" "}
                          <b>"{repeatTestDetailsMaterialTypeName}"</b>. */}
                        </li>
                        <li>
                          Repeat Test Details should be replace with existing
                          Test Details if exists.
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestDetailsRepeatModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showTestParametersModal}
          onHide={setShowTestParametersModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestPrameters}>
              <Form onSubmit={formikTestPrameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{ParametersTestName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="ps-1">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkSelectAllPara`}
                                    name={`chkSelectAllPara`}
                                    checked={selectAllPara}
                                    onChange={(e) => {
                                      handleChangeSelectAllPara(
                                        e?.target?.checked,
                                      );
                                    }}
                                  />
                                </th>
                                <th width="97%" style={{ textAlign: "left" }}>
                                  Parameters
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParametersList?.length > 0 ? (
                                ParametersList?.map((para, iPara) => (
                                  <tr key={`para_${iPara}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${iPara}`}
                                        name={`chkIsSelected${iPara}`}
                                        checked={para.IsSelected}
                                        onChange={(e) => {
                                          formikTestPrameters.setFieldValue(
                                            `ParametersList[${iPara}].IsSelected`,
                                            e?.target?.checked,
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {para?.ParameterName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestParametersModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showMixDesignTestDetailModal}
          onHide={setShowMixDesignTestDetailModal}
          backdrop="static"
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMixDesignTestDetails}>
              <Form onSubmit={formikMixDesignTestDetails.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {MixDesignTestName} (STIPULATIONS FOR PROPORTIONING)
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMixDesignTestDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={4}>
                      <Field
                        name={"GradeDesignation"}
                        label={"Grade Designation"}
                        placeholder={"Grade Designation"}
                        component={CustomInput}
                        maxLength={200}
                        required
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Cement"
                        name="TypeofCementIDEncrypted"
                        placeholder={"Select Type of Cement"}
                        options={optionsTypeOfCement}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <div className="mb-2">
                        <label className="mb-1">
                          Method of Concrete Placing &nbsp;
                        </label>
                        <div className="form-control form-control-sm">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                            name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                            checked={MethodofConcretePlacingIsChute_NonPumpable}
                            onChange={(e) => {
                              formikMixDesignTestDetails.setFieldValue(
                                "MethodofConcretePlacingIsChute_NonPumpable",
                                !MethodofConcretePlacingIsChute_NonPumpable,
                              );
                            }}
                          />
                          <label className="mb-1 ms-1 me-2 mt-1">
                            Chute (Non pumpable) &nbsp;
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`chkMethodofConcretePlacingIsPumping`}
                            name={`chkMethodofConcretePlacingIsPumping`}
                            checked={MethodofConcretePlacingIsPumping}
                            onChange={(e) => {
                              formikMixDesignTestDetails.setFieldValue(
                                "MethodofConcretePlacingIsPumping",
                                !MethodofConcretePlacingIsPumping,
                              );
                            }}
                          />
                          <label className="mb-1 ms-1 mt-1">
                            Pumping &nbsp;
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Mineral Admixture"
                        name="TypeofMineralAdmixtureIDEncrypted"
                        placeholder={"Select Type of Mineral Admixture"}
                        options={optionsTypeOfMineralAdmixture}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"DegreeofSiteControl"}
                        label={"Degree of Site Control"}
                        placeholder={"Degree of Site Control"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Maximum Nominal Size of Aggregate"
                        name="MaximumNominalSizeofAggregateIDEncrypted"
                        placeholder={"Select Maximum Nominal Size of Aggregate"}
                        options={optionsMaximumNominalSizeofAggregate}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"TypeofAggregateFineCoarse"}
                        label={"Type of Aggregate Coarse"}
                        placeholder={"Type of Aggregate Coarse"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Type of Aggregate Fine"
                        name="TypeofAggregateFineIDEncrypted"
                        placeholder={"Select Type of Aggregate Fine"}
                        options={optionsTypeOfAggregateFine}
                        component={CustomSelect}
                      />
                    </Col>

                    <Col lg={4}>
                      <Field
                        label="Environmental Exposure Conditions"
                        name="EnvironmentalExposureConditionsIDEncrypted"
                        placeholder={"Select Environmental Exposure Conditions"}
                        options={optionsEnvironmentralExposureConditions}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MaximumCementContent"}
                        label={"Maximum Cement Content (kg/m3)"}
                        placeholder={"Maximum Cement Content (kg/m3)"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MinimumCementContent"}
                        label={"Minimum Cement Content (kg/m3)"}
                        placeholder={"Minimum Cement Content (kg/m3)"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>

                    <Col lg={4}>
                      <Field
                        type="number"
                        name={"MaximumWaterCementRatio"}
                        label={"Maximum Water Cement Ratio"}
                        placeholder={"Maximum Water Cement Ratio"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name={"Workability"}
                        label={"Workability"}
                        placeholder={"Workability"}
                        component={CustomInput}
                        maxLength={200}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Chemical Admixture Type"
                        name="ChemicalAdmixtureTypeIDEncrypted"
                        placeholder={"Select Chemical Admixture Type"}
                        options={optionsChemicalAdmixtureType}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Chemical Admixture Brand/Batch/ID Mark"
                        name="ChemicalAdmixtureBrandBatchandMarkIDEncrypted"
                        placeholder={"Chemical Admixture Brand/Batch/ID Mark"}
                        options={optionsChemicalAdmixtureBrandBatchMarkId}
                        component={CustomSelect}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name="TransportationTime"
                        label={"Transportation Time"}
                        placeholder={"hh:mm"}
                        component={CustomFlatpickr}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                          time_24hr: true, // Enforces 24-hour format
                          //allowInput: true, // Allows typing
                          minuteIncrement: 1, // Allows setting minutes with up/down arrows
                          static: true, //to solve up-down key not working in modal
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        name="RetentionTime"
                        label={"Retention Time"}
                        placeholder={"hh:mm"}
                        component={CustomFlatpickr}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                          time_24hr: true, // Enforces 24-hour format
                          //allowInput: true, // Allows typing
                          minuteIncrement: 1, // Allows setting minutes with up/down arrows
                          static: true, //to solve up-down key not working in modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam ? (
                    <Button
                      // className="btn btn-primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMixDesignTestDetailModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="5%" className="ps-1"></th>
                                <th width="95%" style={{ textAlign: "left" }}>
                                  Rate Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((tRate, tRateindx) => (
                                  <tr key={`para_${tRateindx}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${tRateindx}`}
                                        name={`chkIsSelected${tRateindx}`}
                                        checked={tRate.IsSelected}
                                        onChange={(e) => {
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${tRateindx}].IsSelected`,
                                            e?.target?.checked,
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {tRate.RateTypeName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {!ViewPrimaryIdParam && MoreTestRatesList?.length > 0 ? (
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddTC_TestAllocation;
